/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ViewAllImport } from './routes/view-all'
import { Route as PrivacyPolicyImport } from './routes/privacy-policy'
import { Route as Import } from './routes/*'
import { Route as TestRouteImport } from './routes/test/route'
import { Route as IframeApiRouteImport } from './routes/iframe-api/route'
import { Route as DashRouteImport } from './routes/dash/route'
import { Route as IndexImport } from './routes/index'
import { Route as ServiceDeskIndexImport } from './routes/service-desk/index'
import { Route as ZnglistSlugImport } from './routes/znglist.$slug'
import { Route as TestUiMetaFieldImport } from './routes/test/ui-meta-field'
import { Route as HubSlugImport } from './routes/hub.$slug'
import { Route as ContentPostIdImport } from './routes/content.$postId'
import { Route as AuthPasswordResetImport } from './routes/auth/password-reset'
import { Route as AuthOauthCallbackImport } from './routes/auth/oauth-callback'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as DashSettingsRouteImport } from './routes/dash/settings/route'
import { Route as DashHubsRouteImport } from './routes/dash/hubs/route'
import { Route as DashCrmRouteImport } from './routes/dash/crm/route'
import { Route as TestThemeIndexImport } from './routes/test/theme/index'
import { Route as DashZnglistsIndexImport } from './routes/dash/znglists/index'
import { Route as DashSettingsIndexImport } from './routes/dash/settings/index'
import { Route as DashHubsIndexImport } from './routes/dash/hubs/index'
import { Route as DashCrmIndexImport } from './routes/dash/crm/index'
import { Route as DashCatalogIndexImport } from './routes/dash/catalog/index'
import { Route as IframeApiStudioRecordVideoImport } from './routes/iframe-api/studio/record-video'
import { Route as DashZnglistsReorderImport } from './routes/dash/znglists/reorder'
import { Route as DashZnglistsZnglistEditImport } from './routes/dash/znglists/$znglistEdit'
import { Route as DashContentAddImport } from './routes/dash/content/add'
import { Route as DashContentEditIdImport } from './routes/dash/content/$editId'
import { Route as AuthSsoLoginImport } from './routes/auth/sso/login'
import { Route as DashSettingsManagementRouteImport } from './routes/dash/settings/management/route'
import { Route as DashSettingsGeneralRouteImport } from './routes/dash/settings/general/route'
import { Route as DashSettingsCustomisationRouteImport } from './routes/dash/settings/customisation/route'
import { Route as DashCrmFormsRouteImport } from './routes/dash/crm/forms/route'
import { Route as DashCrmContactsRouteImport } from './routes/dash/crm/contacts/route'
import { Route as DashContentCategoriesRouteImport } from './routes/dash/content/categories/route'
import { Route as DashHubsPagesIndexImport } from './routes/dash/hubs/pages/index'
import { Route as DashHubsHubsIndexImport } from './routes/dash/hubs/hubs/index'
import { Route as DashCrmFormsIndexImport } from './routes/dash/crm/forms/index'
import { Route as DashCrmContactsIndexImport } from './routes/dash/crm/contacts/index'
import { Route as DashContentCategoriesIndexImport } from './routes/dash/content/categories/index'
import { Route as UsersUserZnglistSlugImport } from './routes/users.$user.znglist.$slug'
import { Route as DashHubsPagesHubPageEditImport } from './routes/dash/hubs/pages/$hubPageEdit'
import { Route as DashHubsHubsReorderImport } from './routes/dash/hubs/hubs/reorder'
import { Route as DashHubsHubsHubEditImport } from './routes/dash/hubs/hubs/$hubEdit'
import { Route as DashCrmFormsFormIdImport } from './routes/dash/crm/forms/$formId'
import { Route as DashCrmContactsListsRouteImport } from './routes/dash/crm/contacts/lists/route'
import { Route as DashCrmContactsImportRouteImport } from './routes/dash/crm/contacts/import/route'
import { Route as DashSettingsManagementUsersIndexImport } from './routes/dash/settings/management/users/index'
import { Route as DashSettingsManagementProfileIndexImport } from './routes/dash/settings/management/profile/index'
import { Route as DashSettingsManagementIntegrationsIndexImport } from './routes/dash/settings/management/integrations/index'
import { Route as DashSettingsManagementAnalyticsIndexImport } from './routes/dash/settings/management/analytics/index'
import { Route as DashSettingsGeneralTagsIndexImport } from './routes/dash/settings/general/tags/index'
import { Route as DashSettingsGeneralSiteSettingsIndexImport } from './routes/dash/settings/general/site-settings/index'
import { Route as DashSettingsGeneralPrivacyPolicyIndexImport } from './routes/dash/settings/general/privacy-policy/index'
import { Route as DashSettingsGeneralHomePageIndexImport } from './routes/dash/settings/general/home-page/index'
import { Route as DashSettingsCustomisationQrCodeIndexImport } from './routes/dash/settings/customisation/qr-code/index'
import { Route as DashSettingsCustomisationPersonalisedVideoIndexImport } from './routes/dash/settings/customisation/personalised-video/index'
import { Route as DashSettingsCustomisationHeaderIndexImport } from './routes/dash/settings/customisation/header/index'
import { Route as DashSettingsCustomisationGlobalStylesIndexImport } from './routes/dash/settings/customisation/global-styles/index'
import { Route as DashSettingsCustomisationFooterIndexImport } from './routes/dash/settings/customisation/footer/index'
import { Route as DashSettingsCustomisationBodyIndexImport } from './routes/dash/settings/customisation/body/index'
import { Route as DashSettingsCustomisationBackendIndexImport } from './routes/dash/settings/customisation/backend/index'
import { Route as DashCrmFormsEntriesIndexImport } from './routes/dash/crm/forms/entries/index'
import { Route as DashCrmContactsListsIndexImport } from './routes/dash/crm/contacts/lists/index'
import { Route as DashCrmContactsImportIndexImport } from './routes/dash/crm/contacts/import/index'
import { Route as DashSettingsManagementUsersCreateImport } from './routes/dash/settings/management/users/create'
import { Route as DashCrmFormsEntriesEntryIdImport } from './routes/dash/crm/forms/entries/$entryId'
import { Route as DashCrmContactsImportStep2Import } from './routes/dash/crm/contacts/import/step-2'
import { Route as DashCrmContactsContactNewImport } from './routes/dash/crm/contacts/contact/new'
import { Route as DashCrmContactsContactContactIdImport } from './routes/dash/crm/contacts/contact/$contactId'
import { Route as DashContentCategoriesIdAddFromCatalogImport } from './routes/dash/content/categories/$id.add-from-catalog'
import { Route as DashSettingsManagementUsersUserRouteImport } from './routes/dash/settings/management/users/$user/route'
import { Route as DashCrmContactsListsListIdRouteImport } from './routes/dash/crm/contacts/lists/$listId/route'
import { Route as DashSettingsManagementIntegrationsHubspotIndexImport } from './routes/dash/settings/management/integrations/hubspot/index'
import { Route as DashCrmContactsListsListIdIndexImport } from './routes/dash/crm/contacts/lists/$listId/index'
import { Route as DashCrmContactsImportFileUploadIndexImport } from './routes/dash/crm/contacts/import/file-upload/index'
import { Route as DashCrmContactsListsListIdHandpickImport } from './routes/dash/crm/contacts/lists/$listId/handpick'
import { Route as DashCrmContactsListsListIdFiltersImport } from './routes/dash/crm/contacts/lists/$listId/filters'

// Create Virtual Routes

const DashAnalyticsIndexLazyImport = createFileRoute('/dash/analytics/')()

// Create/Update Routes

const ViewAllRoute = ViewAllImport.update({
  id: '/view-all',
  path: '/view-all',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any)

const Route = Import.update({
  id: '/*',
  path: '/*',
  getParentRoute: () => rootRoute,
} as any)

const TestRouteRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRoute,
} as any)

const IframeApiRouteRoute = IframeApiRouteImport.update({
  id: '/iframe-api',
  path: '/iframe-api',
  getParentRoute: () => rootRoute,
} as any)

const DashRouteRoute = DashRouteImport.update({
  id: '/dash',
  path: '/dash',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/dash/route.lazy').then((d) => d.Route))

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ServiceDeskIndexRoute = ServiceDeskIndexImport.update({
  id: '/service-desk/',
  path: '/service-desk/',
  getParentRoute: () => rootRoute,
} as any)

const ZnglistSlugRoute = ZnglistSlugImport.update({
  id: '/znglist/$slug',
  path: '/znglist/$slug',
  getParentRoute: () => rootRoute,
} as any)

const TestUiMetaFieldRoute = TestUiMetaFieldImport.update({
  id: '/ui-meta-field',
  path: '/ui-meta-field',
  getParentRoute: () => TestRouteRoute,
} as any)

const HubSlugRoute = HubSlugImport.update({
  id: '/hub/$slug',
  path: '/hub/$slug',
  getParentRoute: () => rootRoute,
} as any)

const ContentPostIdRoute = ContentPostIdImport.update({
  id: '/content/$postId',
  path: '/content/$postId',
  getParentRoute: () => rootRoute,
} as any)

const AuthPasswordResetRoute = AuthPasswordResetImport.update({
  id: '/auth/password-reset',
  path: '/auth/password-reset',
  getParentRoute: () => rootRoute,
} as any)

const AuthOauthCallbackRoute = AuthOauthCallbackImport.update({
  id: '/auth/oauth-callback',
  path: '/auth/oauth-callback',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const DashSettingsRouteRoute = DashSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashRouteRoute,
} as any)

const DashHubsRouteRoute = DashHubsRouteImport.update({
  id: '/hubs',
  path: '/hubs',
  getParentRoute: () => DashRouteRoute,
} as any)

const DashCrmRouteRoute = DashCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => DashRouteRoute,
} as any)

const DashAnalyticsIndexLazyRoute = DashAnalyticsIndexLazyImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => DashRouteRoute,
} as any).lazy(() =>
  import('./routes/dash/analytics/index.lazy').then((d) => d.Route),
)

const TestThemeIndexRoute = TestThemeIndexImport.update({
  id: '/theme/',
  path: '/theme/',
  getParentRoute: () => TestRouteRoute,
} as any)

const DashZnglistsIndexRoute = DashZnglistsIndexImport.update({
  id: '/znglists/',
  path: '/znglists/',
  getParentRoute: () => DashRouteRoute,
} as any).lazy(() =>
  import('./routes/dash/znglists/index.lazy').then((d) => d.Route),
)

const DashSettingsIndexRoute = DashSettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashSettingsRouteRoute,
} as any)

const DashHubsIndexRoute = DashHubsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashHubsRouteRoute,
} as any)

const DashCrmIndexRoute = DashCrmIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashCrmRouteRoute,
} as any)

const DashCatalogIndexRoute = DashCatalogIndexImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => DashRouteRoute,
} as any)

const IframeApiStudioRecordVideoRoute = IframeApiStudioRecordVideoImport.update(
  {
    id: '/studio/record-video',
    path: '/studio/record-video',
    getParentRoute: () => IframeApiRouteRoute,
  } as any,
)

const DashZnglistsReorderRoute = DashZnglistsReorderImport.update({
  id: '/znglists/reorder',
  path: '/znglists/reorder',
  getParentRoute: () => DashRouteRoute,
} as any)

const DashZnglistsZnglistEditRoute = DashZnglistsZnglistEditImport.update({
  id: '/znglists/$znglistEdit',
  path: '/znglists/$znglistEdit',
  getParentRoute: () => DashRouteRoute,
} as any)

const DashContentAddRoute = DashContentAddImport.update({
  id: '/content/add',
  path: '/content/add',
  getParentRoute: () => DashRouteRoute,
} as any)

const DashContentEditIdRoute = DashContentEditIdImport.update({
  id: '/content/$editId',
  path: '/content/$editId',
  getParentRoute: () => DashRouteRoute,
} as any)

const AuthSsoLoginRoute = AuthSsoLoginImport.update({
  id: '/auth/sso/login',
  path: '/auth/sso/login',
  getParentRoute: () => rootRoute,
} as any)

const DashSettingsManagementRouteRoute =
  DashSettingsManagementRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => DashSettingsRouteRoute,
  } as any)

const DashSettingsGeneralRouteRoute = DashSettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => DashSettingsRouteRoute,
} as any)

const DashSettingsCustomisationRouteRoute =
  DashSettingsCustomisationRouteImport.update({
    id: '/customisation',
    path: '/customisation',
    getParentRoute: () => DashSettingsRouteRoute,
  } as any)

const DashCrmFormsRouteRoute = DashCrmFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => DashCrmRouteRoute,
} as any)

const DashCrmContactsRouteRoute = DashCrmContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => DashCrmRouteRoute,
} as any)

const DashContentCategoriesRouteRoute = DashContentCategoriesRouteImport.update(
  {
    id: '/content/categories',
    path: '/content/categories',
    getParentRoute: () => DashRouteRoute,
  } as any,
)

const DashHubsPagesIndexRoute = DashHubsPagesIndexImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => DashHubsRouteRoute,
} as any)

const DashHubsHubsIndexRoute = DashHubsHubsIndexImport.update({
  id: '/hubs/',
  path: '/hubs/',
  getParentRoute: () => DashHubsRouteRoute,
} as any).lazy(() =>
  import('./routes/dash/hubs/hubs/index.lazy').then((d) => d.Route),
)

const DashCrmFormsIndexRoute = DashCrmFormsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashCrmFormsRouteRoute,
} as any)

const DashCrmContactsIndexRoute = DashCrmContactsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashCrmContactsRouteRoute,
} as any)

const DashContentCategoriesIndexRoute = DashContentCategoriesIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => DashContentCategoriesRouteRoute,
  } as any,
)

const UsersUserZnglistSlugRoute = UsersUserZnglistSlugImport.update({
  id: '/users/$user/znglist/$slug',
  path: '/users/$user/znglist/$slug',
  getParentRoute: () => rootRoute,
} as any)

const DashHubsPagesHubPageEditRoute = DashHubsPagesHubPageEditImport.update({
  id: '/pages/$hubPageEdit',
  path: '/pages/$hubPageEdit',
  getParentRoute: () => DashHubsRouteRoute,
} as any)

const DashHubsHubsReorderRoute = DashHubsHubsReorderImport.update({
  id: '/hubs/reorder',
  path: '/hubs/reorder',
  getParentRoute: () => DashHubsRouteRoute,
} as any)

const DashHubsHubsHubEditRoute = DashHubsHubsHubEditImport.update({
  id: '/hubs/$hubEdit',
  path: '/hubs/$hubEdit',
  getParentRoute: () => DashHubsRouteRoute,
} as any)

const DashCrmFormsFormIdRoute = DashCrmFormsFormIdImport.update({
  id: '/$formId',
  path: '/$formId',
  getParentRoute: () => DashCrmFormsRouteRoute,
} as any)

const DashCrmContactsListsRouteRoute = DashCrmContactsListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => DashCrmContactsRouteRoute,
} as any)

const DashCrmContactsImportRouteRoute = DashCrmContactsImportRouteImport.update(
  {
    id: '/import',
    path: '/import',
    getParentRoute: () => DashCrmContactsRouteRoute,
  } as any,
)

const DashSettingsManagementUsersIndexRoute =
  DashSettingsManagementUsersIndexImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => DashSettingsManagementRouteRoute,
  } as any)

const DashSettingsManagementProfileIndexRoute =
  DashSettingsManagementProfileIndexImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => DashSettingsManagementRouteRoute,
  } as any)

const DashSettingsManagementIntegrationsIndexRoute =
  DashSettingsManagementIntegrationsIndexImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => DashSettingsManagementRouteRoute,
  } as any)

const DashSettingsManagementAnalyticsIndexRoute =
  DashSettingsManagementAnalyticsIndexImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => DashSettingsManagementRouteRoute,
  } as any)

const DashSettingsGeneralTagsIndexRoute =
  DashSettingsGeneralTagsIndexImport.update({
    id: '/tags/',
    path: '/tags/',
    getParentRoute: () => DashSettingsGeneralRouteRoute,
  } as any)

const DashSettingsGeneralSiteSettingsIndexRoute =
  DashSettingsGeneralSiteSettingsIndexImport.update({
    id: '/site-settings/',
    path: '/site-settings/',
    getParentRoute: () => DashSettingsGeneralRouteRoute,
  } as any)

const DashSettingsGeneralPrivacyPolicyIndexRoute =
  DashSettingsGeneralPrivacyPolicyIndexImport.update({
    id: '/privacy-policy/',
    path: '/privacy-policy/',
    getParentRoute: () => DashSettingsGeneralRouteRoute,
  } as any)

const DashSettingsGeneralHomePageIndexRoute =
  DashSettingsGeneralHomePageIndexImport.update({
    id: '/home-page/',
    path: '/home-page/',
    getParentRoute: () => DashSettingsGeneralRouteRoute,
  } as any)

const DashSettingsCustomisationQrCodeIndexRoute =
  DashSettingsCustomisationQrCodeIndexImport.update({
    id: '/qr-code/',
    path: '/qr-code/',
    getParentRoute: () => DashSettingsCustomisationRouteRoute,
  } as any)

const DashSettingsCustomisationPersonalisedVideoIndexRoute =
  DashSettingsCustomisationPersonalisedVideoIndexImport.update({
    id: '/personalised-video/',
    path: '/personalised-video/',
    getParentRoute: () => DashSettingsCustomisationRouteRoute,
  } as any)

const DashSettingsCustomisationHeaderIndexRoute =
  DashSettingsCustomisationHeaderIndexImport.update({
    id: '/header/',
    path: '/header/',
    getParentRoute: () => DashSettingsCustomisationRouteRoute,
  } as any)

const DashSettingsCustomisationGlobalStylesIndexRoute =
  DashSettingsCustomisationGlobalStylesIndexImport.update({
    id: '/global-styles/',
    path: '/global-styles/',
    getParentRoute: () => DashSettingsCustomisationRouteRoute,
  } as any)

const DashSettingsCustomisationFooterIndexRoute =
  DashSettingsCustomisationFooterIndexImport.update({
    id: '/footer/',
    path: '/footer/',
    getParentRoute: () => DashSettingsCustomisationRouteRoute,
  } as any)

const DashSettingsCustomisationBodyIndexRoute =
  DashSettingsCustomisationBodyIndexImport.update({
    id: '/body/',
    path: '/body/',
    getParentRoute: () => DashSettingsCustomisationRouteRoute,
  } as any)

const DashSettingsCustomisationBackendIndexRoute =
  DashSettingsCustomisationBackendIndexImport.update({
    id: '/backend/',
    path: '/backend/',
    getParentRoute: () => DashSettingsCustomisationRouteRoute,
  } as any)

const DashCrmFormsEntriesIndexRoute = DashCrmFormsEntriesIndexImport.update({
  id: '/entries/',
  path: '/entries/',
  getParentRoute: () => DashCrmFormsRouteRoute,
} as any)

const DashCrmContactsListsIndexRoute = DashCrmContactsListsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashCrmContactsListsRouteRoute,
} as any)

const DashCrmContactsImportIndexRoute = DashCrmContactsImportIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => DashCrmContactsImportRouteRoute,
  } as any,
)

const DashSettingsManagementUsersCreateRoute =
  DashSettingsManagementUsersCreateImport.update({
    id: '/users/create',
    path: '/users/create',
    getParentRoute: () => DashSettingsManagementRouteRoute,
  } as any)

const DashCrmFormsEntriesEntryIdRoute = DashCrmFormsEntriesEntryIdImport.update(
  {
    id: '/entries/$entryId',
    path: '/entries/$entryId',
    getParentRoute: () => DashCrmFormsRouteRoute,
  } as any,
)

const DashCrmContactsImportStep2Route = DashCrmContactsImportStep2Import.update(
  {
    id: '/step-2',
    path: '/step-2',
    getParentRoute: () => DashCrmContactsImportRouteRoute,
  } as any,
)

const DashCrmContactsContactNewRoute = DashCrmContactsContactNewImport.update({
  id: '/contact/new',
  path: '/contact/new',
  getParentRoute: () => DashCrmContactsRouteRoute,
} as any)

const DashCrmContactsContactContactIdRoute =
  DashCrmContactsContactContactIdImport.update({
    id: '/contact/$contactId',
    path: '/contact/$contactId',
    getParentRoute: () => DashCrmContactsRouteRoute,
  } as any)

const DashContentCategoriesIdAddFromCatalogRoute =
  DashContentCategoriesIdAddFromCatalogImport.update({
    id: '/$id/add-from-catalog',
    path: '/$id/add-from-catalog',
    getParentRoute: () => DashContentCategoriesRouteRoute,
  } as any)

const DashSettingsManagementUsersUserRouteRoute =
  DashSettingsManagementUsersUserRouteImport.update({
    id: '/users/$user',
    path: '/users/$user',
    getParentRoute: () => DashSettingsManagementRouteRoute,
  } as any)

const DashCrmContactsListsListIdRouteRoute =
  DashCrmContactsListsListIdRouteImport.update({
    id: '/$listId',
    path: '/$listId',
    getParentRoute: () => DashCrmContactsListsRouteRoute,
  } as any)

const DashSettingsManagementIntegrationsHubspotIndexRoute =
  DashSettingsManagementIntegrationsHubspotIndexImport.update({
    id: '/integrations/hubspot/',
    path: '/integrations/hubspot/',
    getParentRoute: () => DashSettingsManagementRouteRoute,
  } as any)

const DashCrmContactsListsListIdIndexRoute =
  DashCrmContactsListsListIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashCrmContactsListsListIdRouteRoute,
  } as any)

const DashCrmContactsImportFileUploadIndexRoute =
  DashCrmContactsImportFileUploadIndexImport.update({
    id: '/file-upload/',
    path: '/file-upload/',
    getParentRoute: () => DashCrmContactsImportRouteRoute,
  } as any)

const DashCrmContactsListsListIdHandpickRoute =
  DashCrmContactsListsListIdHandpickImport.update({
    id: '/handpick',
    path: '/handpick',
    getParentRoute: () => DashCrmContactsListsListIdRouteRoute,
  } as any)

const DashCrmContactsListsListIdFiltersRoute =
  DashCrmContactsListsListIdFiltersImport.update({
    id: '/filters',
    path: '/filters',
    getParentRoute: () => DashCrmContactsListsListIdRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/dash': {
      id: '/dash'
      path: '/dash'
      fullPath: '/dash'
      preLoaderRoute: typeof DashRouteImport
      parentRoute: typeof rootRoute
    }
    '/iframe-api': {
      id: '/iframe-api'
      path: '/iframe-api'
      fullPath: '/iframe-api'
      preLoaderRoute: typeof IframeApiRouteImport
      parentRoute: typeof rootRoute
    }
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRoute
    }
    '/*': {
      id: '/*'
      path: '/*'
      fullPath: '/*'
      preLoaderRoute: typeof Import
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    '/view-all': {
      id: '/view-all'
      path: '/view-all'
      fullPath: '/view-all'
      preLoaderRoute: typeof ViewAllImport
      parentRoute: typeof rootRoute
    }
    '/dash/crm': {
      id: '/dash/crm'
      path: '/crm'
      fullPath: '/dash/crm'
      preLoaderRoute: typeof DashCrmRouteImport
      parentRoute: typeof DashRouteImport
    }
    '/dash/hubs': {
      id: '/dash/hubs'
      path: '/hubs'
      fullPath: '/dash/hubs'
      preLoaderRoute: typeof DashHubsRouteImport
      parentRoute: typeof DashRouteImport
    }
    '/dash/settings': {
      id: '/dash/settings'
      path: '/settings'
      fullPath: '/dash/settings'
      preLoaderRoute: typeof DashSettingsRouteImport
      parentRoute: typeof DashRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/auth/oauth-callback': {
      id: '/auth/oauth-callback'
      path: '/auth/oauth-callback'
      fullPath: '/auth/oauth-callback'
      preLoaderRoute: typeof AuthOauthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/auth/password-reset': {
      id: '/auth/password-reset'
      path: '/auth/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetImport
      parentRoute: typeof rootRoute
    }
    '/content/$postId': {
      id: '/content/$postId'
      path: '/content/$postId'
      fullPath: '/content/$postId'
      preLoaderRoute: typeof ContentPostIdImport
      parentRoute: typeof rootRoute
    }
    '/hub/$slug': {
      id: '/hub/$slug'
      path: '/hub/$slug'
      fullPath: '/hub/$slug'
      preLoaderRoute: typeof HubSlugImport
      parentRoute: typeof rootRoute
    }
    '/test/ui-meta-field': {
      id: '/test/ui-meta-field'
      path: '/ui-meta-field'
      fullPath: '/test/ui-meta-field'
      preLoaderRoute: typeof TestUiMetaFieldImport
      parentRoute: typeof TestRouteImport
    }
    '/znglist/$slug': {
      id: '/znglist/$slug'
      path: '/znglist/$slug'
      fullPath: '/znglist/$slug'
      preLoaderRoute: typeof ZnglistSlugImport
      parentRoute: typeof rootRoute
    }
    '/service-desk/': {
      id: '/service-desk/'
      path: '/service-desk'
      fullPath: '/service-desk'
      preLoaderRoute: typeof ServiceDeskIndexImport
      parentRoute: typeof rootRoute
    }
    '/dash/content/categories': {
      id: '/dash/content/categories'
      path: '/content/categories'
      fullPath: '/dash/content/categories'
      preLoaderRoute: typeof DashContentCategoriesRouteImport
      parentRoute: typeof DashRouteImport
    }
    '/dash/crm/contacts': {
      id: '/dash/crm/contacts'
      path: '/contacts'
      fullPath: '/dash/crm/contacts'
      preLoaderRoute: typeof DashCrmContactsRouteImport
      parentRoute: typeof DashCrmRouteImport
    }
    '/dash/crm/forms': {
      id: '/dash/crm/forms'
      path: '/forms'
      fullPath: '/dash/crm/forms'
      preLoaderRoute: typeof DashCrmFormsRouteImport
      parentRoute: typeof DashCrmRouteImport
    }
    '/dash/settings/customisation': {
      id: '/dash/settings/customisation'
      path: '/customisation'
      fullPath: '/dash/settings/customisation'
      preLoaderRoute: typeof DashSettingsCustomisationRouteImport
      parentRoute: typeof DashSettingsRouteImport
    }
    '/dash/settings/general': {
      id: '/dash/settings/general'
      path: '/general'
      fullPath: '/dash/settings/general'
      preLoaderRoute: typeof DashSettingsGeneralRouteImport
      parentRoute: typeof DashSettingsRouteImport
    }
    '/dash/settings/management': {
      id: '/dash/settings/management'
      path: '/management'
      fullPath: '/dash/settings/management'
      preLoaderRoute: typeof DashSettingsManagementRouteImport
      parentRoute: typeof DashSettingsRouteImport
    }
    '/auth/sso/login': {
      id: '/auth/sso/login'
      path: '/auth/sso/login'
      fullPath: '/auth/sso/login'
      preLoaderRoute: typeof AuthSsoLoginImport
      parentRoute: typeof rootRoute
    }
    '/dash/content/$editId': {
      id: '/dash/content/$editId'
      path: '/content/$editId'
      fullPath: '/dash/content/$editId'
      preLoaderRoute: typeof DashContentEditIdImport
      parentRoute: typeof DashRouteImport
    }
    '/dash/content/add': {
      id: '/dash/content/add'
      path: '/content/add'
      fullPath: '/dash/content/add'
      preLoaderRoute: typeof DashContentAddImport
      parentRoute: typeof DashRouteImport
    }
    '/dash/znglists/$znglistEdit': {
      id: '/dash/znglists/$znglistEdit'
      path: '/znglists/$znglistEdit'
      fullPath: '/dash/znglists/$znglistEdit'
      preLoaderRoute: typeof DashZnglistsZnglistEditImport
      parentRoute: typeof DashRouteImport
    }
    '/dash/znglists/reorder': {
      id: '/dash/znglists/reorder'
      path: '/znglists/reorder'
      fullPath: '/dash/znglists/reorder'
      preLoaderRoute: typeof DashZnglistsReorderImport
      parentRoute: typeof DashRouteImport
    }
    '/iframe-api/studio/record-video': {
      id: '/iframe-api/studio/record-video'
      path: '/studio/record-video'
      fullPath: '/iframe-api/studio/record-video'
      preLoaderRoute: typeof IframeApiStudioRecordVideoImport
      parentRoute: typeof IframeApiRouteImport
    }
    '/dash/catalog/': {
      id: '/dash/catalog/'
      path: '/catalog'
      fullPath: '/dash/catalog'
      preLoaderRoute: typeof DashCatalogIndexImport
      parentRoute: typeof DashRouteImport
    }
    '/dash/crm/': {
      id: '/dash/crm/'
      path: '/'
      fullPath: '/dash/crm/'
      preLoaderRoute: typeof DashCrmIndexImport
      parentRoute: typeof DashCrmRouteImport
    }
    '/dash/hubs/': {
      id: '/dash/hubs/'
      path: '/'
      fullPath: '/dash/hubs/'
      preLoaderRoute: typeof DashHubsIndexImport
      parentRoute: typeof DashHubsRouteImport
    }
    '/dash/settings/': {
      id: '/dash/settings/'
      path: '/'
      fullPath: '/dash/settings/'
      preLoaderRoute: typeof DashSettingsIndexImport
      parentRoute: typeof DashSettingsRouteImport
    }
    '/dash/znglists/': {
      id: '/dash/znglists/'
      path: '/znglists'
      fullPath: '/dash/znglists'
      preLoaderRoute: typeof DashZnglistsIndexImport
      parentRoute: typeof DashRouteImport
    }
    '/test/theme/': {
      id: '/test/theme/'
      path: '/theme'
      fullPath: '/test/theme'
      preLoaderRoute: typeof TestThemeIndexImport
      parentRoute: typeof TestRouteImport
    }
    '/dash/analytics/': {
      id: '/dash/analytics/'
      path: '/analytics'
      fullPath: '/dash/analytics'
      preLoaderRoute: typeof DashAnalyticsIndexLazyImport
      parentRoute: typeof DashRouteImport
    }
    '/dash/crm/contacts/import': {
      id: '/dash/crm/contacts/import'
      path: '/import'
      fullPath: '/dash/crm/contacts/import'
      preLoaderRoute: typeof DashCrmContactsImportRouteImport
      parentRoute: typeof DashCrmContactsRouteImport
    }
    '/dash/crm/contacts/lists': {
      id: '/dash/crm/contacts/lists'
      path: '/lists'
      fullPath: '/dash/crm/contacts/lists'
      preLoaderRoute: typeof DashCrmContactsListsRouteImport
      parentRoute: typeof DashCrmContactsRouteImport
    }
    '/dash/crm/forms/$formId': {
      id: '/dash/crm/forms/$formId'
      path: '/$formId'
      fullPath: '/dash/crm/forms/$formId'
      preLoaderRoute: typeof DashCrmFormsFormIdImport
      parentRoute: typeof DashCrmFormsRouteImport
    }
    '/dash/hubs/hubs/$hubEdit': {
      id: '/dash/hubs/hubs/$hubEdit'
      path: '/hubs/$hubEdit'
      fullPath: '/dash/hubs/hubs/$hubEdit'
      preLoaderRoute: typeof DashHubsHubsHubEditImport
      parentRoute: typeof DashHubsRouteImport
    }
    '/dash/hubs/hubs/reorder': {
      id: '/dash/hubs/hubs/reorder'
      path: '/hubs/reorder'
      fullPath: '/dash/hubs/hubs/reorder'
      preLoaderRoute: typeof DashHubsHubsReorderImport
      parentRoute: typeof DashHubsRouteImport
    }
    '/dash/hubs/pages/$hubPageEdit': {
      id: '/dash/hubs/pages/$hubPageEdit'
      path: '/pages/$hubPageEdit'
      fullPath: '/dash/hubs/pages/$hubPageEdit'
      preLoaderRoute: typeof DashHubsPagesHubPageEditImport
      parentRoute: typeof DashHubsRouteImport
    }
    '/users/$user/znglist/$slug': {
      id: '/users/$user/znglist/$slug'
      path: '/users/$user/znglist/$slug'
      fullPath: '/users/$user/znglist/$slug'
      preLoaderRoute: typeof UsersUserZnglistSlugImport
      parentRoute: typeof rootRoute
    }
    '/dash/content/categories/': {
      id: '/dash/content/categories/'
      path: '/'
      fullPath: '/dash/content/categories/'
      preLoaderRoute: typeof DashContentCategoriesIndexImport
      parentRoute: typeof DashContentCategoriesRouteImport
    }
    '/dash/crm/contacts/': {
      id: '/dash/crm/contacts/'
      path: '/'
      fullPath: '/dash/crm/contacts/'
      preLoaderRoute: typeof DashCrmContactsIndexImport
      parentRoute: typeof DashCrmContactsRouteImport
    }
    '/dash/crm/forms/': {
      id: '/dash/crm/forms/'
      path: '/'
      fullPath: '/dash/crm/forms/'
      preLoaderRoute: typeof DashCrmFormsIndexImport
      parentRoute: typeof DashCrmFormsRouteImport
    }
    '/dash/hubs/hubs/': {
      id: '/dash/hubs/hubs/'
      path: '/hubs'
      fullPath: '/dash/hubs/hubs'
      preLoaderRoute: typeof DashHubsHubsIndexImport
      parentRoute: typeof DashHubsRouteImport
    }
    '/dash/hubs/pages/': {
      id: '/dash/hubs/pages/'
      path: '/pages'
      fullPath: '/dash/hubs/pages'
      preLoaderRoute: typeof DashHubsPagesIndexImport
      parentRoute: typeof DashHubsRouteImport
    }
    '/dash/crm/contacts/lists/$listId': {
      id: '/dash/crm/contacts/lists/$listId'
      path: '/$listId'
      fullPath: '/dash/crm/contacts/lists/$listId'
      preLoaderRoute: typeof DashCrmContactsListsListIdRouteImport
      parentRoute: typeof DashCrmContactsListsRouteImport
    }
    '/dash/settings/management/users/$user': {
      id: '/dash/settings/management/users/$user'
      path: '/users/$user'
      fullPath: '/dash/settings/management/users/$user'
      preLoaderRoute: typeof DashSettingsManagementUsersUserRouteImport
      parentRoute: typeof DashSettingsManagementRouteImport
    }
    '/dash/content/categories/$id/add-from-catalog': {
      id: '/dash/content/categories/$id/add-from-catalog'
      path: '/$id/add-from-catalog'
      fullPath: '/dash/content/categories/$id/add-from-catalog'
      preLoaderRoute: typeof DashContentCategoriesIdAddFromCatalogImport
      parentRoute: typeof DashContentCategoriesRouteImport
    }
    '/dash/crm/contacts/contact/$contactId': {
      id: '/dash/crm/contacts/contact/$contactId'
      path: '/contact/$contactId'
      fullPath: '/dash/crm/contacts/contact/$contactId'
      preLoaderRoute: typeof DashCrmContactsContactContactIdImport
      parentRoute: typeof DashCrmContactsRouteImport
    }
    '/dash/crm/contacts/contact/new': {
      id: '/dash/crm/contacts/contact/new'
      path: '/contact/new'
      fullPath: '/dash/crm/contacts/contact/new'
      preLoaderRoute: typeof DashCrmContactsContactNewImport
      parentRoute: typeof DashCrmContactsRouteImport
    }
    '/dash/crm/contacts/import/step-2': {
      id: '/dash/crm/contacts/import/step-2'
      path: '/step-2'
      fullPath: '/dash/crm/contacts/import/step-2'
      preLoaderRoute: typeof DashCrmContactsImportStep2Import
      parentRoute: typeof DashCrmContactsImportRouteImport
    }
    '/dash/crm/forms/entries/$entryId': {
      id: '/dash/crm/forms/entries/$entryId'
      path: '/entries/$entryId'
      fullPath: '/dash/crm/forms/entries/$entryId'
      preLoaderRoute: typeof DashCrmFormsEntriesEntryIdImport
      parentRoute: typeof DashCrmFormsRouteImport
    }
    '/dash/settings/management/users/create': {
      id: '/dash/settings/management/users/create'
      path: '/users/create'
      fullPath: '/dash/settings/management/users/create'
      preLoaderRoute: typeof DashSettingsManagementUsersCreateImport
      parentRoute: typeof DashSettingsManagementRouteImport
    }
    '/dash/crm/contacts/import/': {
      id: '/dash/crm/contacts/import/'
      path: '/'
      fullPath: '/dash/crm/contacts/import/'
      preLoaderRoute: typeof DashCrmContactsImportIndexImport
      parentRoute: typeof DashCrmContactsImportRouteImport
    }
    '/dash/crm/contacts/lists/': {
      id: '/dash/crm/contacts/lists/'
      path: '/'
      fullPath: '/dash/crm/contacts/lists/'
      preLoaderRoute: typeof DashCrmContactsListsIndexImport
      parentRoute: typeof DashCrmContactsListsRouteImport
    }
    '/dash/crm/forms/entries/': {
      id: '/dash/crm/forms/entries/'
      path: '/entries'
      fullPath: '/dash/crm/forms/entries'
      preLoaderRoute: typeof DashCrmFormsEntriesIndexImport
      parentRoute: typeof DashCrmFormsRouteImport
    }
    '/dash/settings/customisation/backend/': {
      id: '/dash/settings/customisation/backend/'
      path: '/backend'
      fullPath: '/dash/settings/customisation/backend'
      preLoaderRoute: typeof DashSettingsCustomisationBackendIndexImport
      parentRoute: typeof DashSettingsCustomisationRouteImport
    }
    '/dash/settings/customisation/body/': {
      id: '/dash/settings/customisation/body/'
      path: '/body'
      fullPath: '/dash/settings/customisation/body'
      preLoaderRoute: typeof DashSettingsCustomisationBodyIndexImport
      parentRoute: typeof DashSettingsCustomisationRouteImport
    }
    '/dash/settings/customisation/footer/': {
      id: '/dash/settings/customisation/footer/'
      path: '/footer'
      fullPath: '/dash/settings/customisation/footer'
      preLoaderRoute: typeof DashSettingsCustomisationFooterIndexImport
      parentRoute: typeof DashSettingsCustomisationRouteImport
    }
    '/dash/settings/customisation/global-styles/': {
      id: '/dash/settings/customisation/global-styles/'
      path: '/global-styles'
      fullPath: '/dash/settings/customisation/global-styles'
      preLoaderRoute: typeof DashSettingsCustomisationGlobalStylesIndexImport
      parentRoute: typeof DashSettingsCustomisationRouteImport
    }
    '/dash/settings/customisation/header/': {
      id: '/dash/settings/customisation/header/'
      path: '/header'
      fullPath: '/dash/settings/customisation/header'
      preLoaderRoute: typeof DashSettingsCustomisationHeaderIndexImport
      parentRoute: typeof DashSettingsCustomisationRouteImport
    }
    '/dash/settings/customisation/personalised-video/': {
      id: '/dash/settings/customisation/personalised-video/'
      path: '/personalised-video'
      fullPath: '/dash/settings/customisation/personalised-video'
      preLoaderRoute: typeof DashSettingsCustomisationPersonalisedVideoIndexImport
      parentRoute: typeof DashSettingsCustomisationRouteImport
    }
    '/dash/settings/customisation/qr-code/': {
      id: '/dash/settings/customisation/qr-code/'
      path: '/qr-code'
      fullPath: '/dash/settings/customisation/qr-code'
      preLoaderRoute: typeof DashSettingsCustomisationQrCodeIndexImport
      parentRoute: typeof DashSettingsCustomisationRouteImport
    }
    '/dash/settings/general/home-page/': {
      id: '/dash/settings/general/home-page/'
      path: '/home-page'
      fullPath: '/dash/settings/general/home-page'
      preLoaderRoute: typeof DashSettingsGeneralHomePageIndexImport
      parentRoute: typeof DashSettingsGeneralRouteImport
    }
    '/dash/settings/general/privacy-policy/': {
      id: '/dash/settings/general/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/dash/settings/general/privacy-policy'
      preLoaderRoute: typeof DashSettingsGeneralPrivacyPolicyIndexImport
      parentRoute: typeof DashSettingsGeneralRouteImport
    }
    '/dash/settings/general/site-settings/': {
      id: '/dash/settings/general/site-settings/'
      path: '/site-settings'
      fullPath: '/dash/settings/general/site-settings'
      preLoaderRoute: typeof DashSettingsGeneralSiteSettingsIndexImport
      parentRoute: typeof DashSettingsGeneralRouteImport
    }
    '/dash/settings/general/tags/': {
      id: '/dash/settings/general/tags/'
      path: '/tags'
      fullPath: '/dash/settings/general/tags'
      preLoaderRoute: typeof DashSettingsGeneralTagsIndexImport
      parentRoute: typeof DashSettingsGeneralRouteImport
    }
    '/dash/settings/management/analytics/': {
      id: '/dash/settings/management/analytics/'
      path: '/analytics'
      fullPath: '/dash/settings/management/analytics'
      preLoaderRoute: typeof DashSettingsManagementAnalyticsIndexImport
      parentRoute: typeof DashSettingsManagementRouteImport
    }
    '/dash/settings/management/integrations/': {
      id: '/dash/settings/management/integrations/'
      path: '/integrations'
      fullPath: '/dash/settings/management/integrations'
      preLoaderRoute: typeof DashSettingsManagementIntegrationsIndexImport
      parentRoute: typeof DashSettingsManagementRouteImport
    }
    '/dash/settings/management/profile/': {
      id: '/dash/settings/management/profile/'
      path: '/profile'
      fullPath: '/dash/settings/management/profile'
      preLoaderRoute: typeof DashSettingsManagementProfileIndexImport
      parentRoute: typeof DashSettingsManagementRouteImport
    }
    '/dash/settings/management/users/': {
      id: '/dash/settings/management/users/'
      path: '/users'
      fullPath: '/dash/settings/management/users'
      preLoaderRoute: typeof DashSettingsManagementUsersIndexImport
      parentRoute: typeof DashSettingsManagementRouteImport
    }
    '/dash/crm/contacts/lists/$listId/filters': {
      id: '/dash/crm/contacts/lists/$listId/filters'
      path: '/filters'
      fullPath: '/dash/crm/contacts/lists/$listId/filters'
      preLoaderRoute: typeof DashCrmContactsListsListIdFiltersImport
      parentRoute: typeof DashCrmContactsListsListIdRouteImport
    }
    '/dash/crm/contacts/lists/$listId/handpick': {
      id: '/dash/crm/contacts/lists/$listId/handpick'
      path: '/handpick'
      fullPath: '/dash/crm/contacts/lists/$listId/handpick'
      preLoaderRoute: typeof DashCrmContactsListsListIdHandpickImport
      parentRoute: typeof DashCrmContactsListsListIdRouteImport
    }
    '/dash/crm/contacts/import/file-upload/': {
      id: '/dash/crm/contacts/import/file-upload/'
      path: '/file-upload'
      fullPath: '/dash/crm/contacts/import/file-upload'
      preLoaderRoute: typeof DashCrmContactsImportFileUploadIndexImport
      parentRoute: typeof DashCrmContactsImportRouteImport
    }
    '/dash/crm/contacts/lists/$listId/': {
      id: '/dash/crm/contacts/lists/$listId/'
      path: '/'
      fullPath: '/dash/crm/contacts/lists/$listId/'
      preLoaderRoute: typeof DashCrmContactsListsListIdIndexImport
      parentRoute: typeof DashCrmContactsListsListIdRouteImport
    }
    '/dash/settings/management/integrations/hubspot/': {
      id: '/dash/settings/management/integrations/hubspot/'
      path: '/integrations/hubspot'
      fullPath: '/dash/settings/management/integrations/hubspot'
      preLoaderRoute: typeof DashSettingsManagementIntegrationsHubspotIndexImport
      parentRoute: typeof DashSettingsManagementRouteImport
    }
  }
}

// Create and export the route tree

interface DashCrmContactsImportRouteRouteChildren {
  DashCrmContactsImportStep2Route: typeof DashCrmContactsImportStep2Route
  DashCrmContactsImportIndexRoute: typeof DashCrmContactsImportIndexRoute
  DashCrmContactsImportFileUploadIndexRoute: typeof DashCrmContactsImportFileUploadIndexRoute
}

const DashCrmContactsImportRouteRouteChildren: DashCrmContactsImportRouteRouteChildren =
  {
    DashCrmContactsImportStep2Route: DashCrmContactsImportStep2Route,
    DashCrmContactsImportIndexRoute: DashCrmContactsImportIndexRoute,
    DashCrmContactsImportFileUploadIndexRoute:
      DashCrmContactsImportFileUploadIndexRoute,
  }

const DashCrmContactsImportRouteRouteWithChildren =
  DashCrmContactsImportRouteRoute._addFileChildren(
    DashCrmContactsImportRouteRouteChildren,
  )

interface DashCrmContactsListsListIdRouteRouteChildren {
  DashCrmContactsListsListIdFiltersRoute: typeof DashCrmContactsListsListIdFiltersRoute
  DashCrmContactsListsListIdHandpickRoute: typeof DashCrmContactsListsListIdHandpickRoute
  DashCrmContactsListsListIdIndexRoute: typeof DashCrmContactsListsListIdIndexRoute
}

const DashCrmContactsListsListIdRouteRouteChildren: DashCrmContactsListsListIdRouteRouteChildren =
  {
    DashCrmContactsListsListIdFiltersRoute:
      DashCrmContactsListsListIdFiltersRoute,
    DashCrmContactsListsListIdHandpickRoute:
      DashCrmContactsListsListIdHandpickRoute,
    DashCrmContactsListsListIdIndexRoute: DashCrmContactsListsListIdIndexRoute,
  }

const DashCrmContactsListsListIdRouteRouteWithChildren =
  DashCrmContactsListsListIdRouteRoute._addFileChildren(
    DashCrmContactsListsListIdRouteRouteChildren,
  )

interface DashCrmContactsListsRouteRouteChildren {
  DashCrmContactsListsListIdRouteRoute: typeof DashCrmContactsListsListIdRouteRouteWithChildren
  DashCrmContactsListsIndexRoute: typeof DashCrmContactsListsIndexRoute
}

const DashCrmContactsListsRouteRouteChildren: DashCrmContactsListsRouteRouteChildren =
  {
    DashCrmContactsListsListIdRouteRoute:
      DashCrmContactsListsListIdRouteRouteWithChildren,
    DashCrmContactsListsIndexRoute: DashCrmContactsListsIndexRoute,
  }

const DashCrmContactsListsRouteRouteWithChildren =
  DashCrmContactsListsRouteRoute._addFileChildren(
    DashCrmContactsListsRouteRouteChildren,
  )

interface DashCrmContactsRouteRouteChildren {
  DashCrmContactsImportRouteRoute: typeof DashCrmContactsImportRouteRouteWithChildren
  DashCrmContactsListsRouteRoute: typeof DashCrmContactsListsRouteRouteWithChildren
  DashCrmContactsIndexRoute: typeof DashCrmContactsIndexRoute
  DashCrmContactsContactContactIdRoute: typeof DashCrmContactsContactContactIdRoute
  DashCrmContactsContactNewRoute: typeof DashCrmContactsContactNewRoute
}

const DashCrmContactsRouteRouteChildren: DashCrmContactsRouteRouteChildren = {
  DashCrmContactsImportRouteRoute: DashCrmContactsImportRouteRouteWithChildren,
  DashCrmContactsListsRouteRoute: DashCrmContactsListsRouteRouteWithChildren,
  DashCrmContactsIndexRoute: DashCrmContactsIndexRoute,
  DashCrmContactsContactContactIdRoute: DashCrmContactsContactContactIdRoute,
  DashCrmContactsContactNewRoute: DashCrmContactsContactNewRoute,
}

const DashCrmContactsRouteRouteWithChildren =
  DashCrmContactsRouteRoute._addFileChildren(DashCrmContactsRouteRouteChildren)

interface DashCrmFormsRouteRouteChildren {
  DashCrmFormsFormIdRoute: typeof DashCrmFormsFormIdRoute
  DashCrmFormsIndexRoute: typeof DashCrmFormsIndexRoute
  DashCrmFormsEntriesEntryIdRoute: typeof DashCrmFormsEntriesEntryIdRoute
  DashCrmFormsEntriesIndexRoute: typeof DashCrmFormsEntriesIndexRoute
}

const DashCrmFormsRouteRouteChildren: DashCrmFormsRouteRouteChildren = {
  DashCrmFormsFormIdRoute: DashCrmFormsFormIdRoute,
  DashCrmFormsIndexRoute: DashCrmFormsIndexRoute,
  DashCrmFormsEntriesEntryIdRoute: DashCrmFormsEntriesEntryIdRoute,
  DashCrmFormsEntriesIndexRoute: DashCrmFormsEntriesIndexRoute,
}

const DashCrmFormsRouteRouteWithChildren =
  DashCrmFormsRouteRoute._addFileChildren(DashCrmFormsRouteRouteChildren)

interface DashCrmRouteRouteChildren {
  DashCrmContactsRouteRoute: typeof DashCrmContactsRouteRouteWithChildren
  DashCrmFormsRouteRoute: typeof DashCrmFormsRouteRouteWithChildren
  DashCrmIndexRoute: typeof DashCrmIndexRoute
}

const DashCrmRouteRouteChildren: DashCrmRouteRouteChildren = {
  DashCrmContactsRouteRoute: DashCrmContactsRouteRouteWithChildren,
  DashCrmFormsRouteRoute: DashCrmFormsRouteRouteWithChildren,
  DashCrmIndexRoute: DashCrmIndexRoute,
}

const DashCrmRouteRouteWithChildren = DashCrmRouteRoute._addFileChildren(
  DashCrmRouteRouteChildren,
)

interface DashHubsRouteRouteChildren {
  DashHubsIndexRoute: typeof DashHubsIndexRoute
  DashHubsHubsHubEditRoute: typeof DashHubsHubsHubEditRoute
  DashHubsHubsReorderRoute: typeof DashHubsHubsReorderRoute
  DashHubsPagesHubPageEditRoute: typeof DashHubsPagesHubPageEditRoute
  DashHubsHubsIndexRoute: typeof DashHubsHubsIndexRoute
  DashHubsPagesIndexRoute: typeof DashHubsPagesIndexRoute
}

const DashHubsRouteRouteChildren: DashHubsRouteRouteChildren = {
  DashHubsIndexRoute: DashHubsIndexRoute,
  DashHubsHubsHubEditRoute: DashHubsHubsHubEditRoute,
  DashHubsHubsReorderRoute: DashHubsHubsReorderRoute,
  DashHubsPagesHubPageEditRoute: DashHubsPagesHubPageEditRoute,
  DashHubsHubsIndexRoute: DashHubsHubsIndexRoute,
  DashHubsPagesIndexRoute: DashHubsPagesIndexRoute,
}

const DashHubsRouteRouteWithChildren = DashHubsRouteRoute._addFileChildren(
  DashHubsRouteRouteChildren,
)

interface DashSettingsCustomisationRouteRouteChildren {
  DashSettingsCustomisationBackendIndexRoute: typeof DashSettingsCustomisationBackendIndexRoute
  DashSettingsCustomisationBodyIndexRoute: typeof DashSettingsCustomisationBodyIndexRoute
  DashSettingsCustomisationFooterIndexRoute: typeof DashSettingsCustomisationFooterIndexRoute
  DashSettingsCustomisationGlobalStylesIndexRoute: typeof DashSettingsCustomisationGlobalStylesIndexRoute
  DashSettingsCustomisationHeaderIndexRoute: typeof DashSettingsCustomisationHeaderIndexRoute
  DashSettingsCustomisationPersonalisedVideoIndexRoute: typeof DashSettingsCustomisationPersonalisedVideoIndexRoute
  DashSettingsCustomisationQrCodeIndexRoute: typeof DashSettingsCustomisationQrCodeIndexRoute
}

const DashSettingsCustomisationRouteRouteChildren: DashSettingsCustomisationRouteRouteChildren =
  {
    DashSettingsCustomisationBackendIndexRoute:
      DashSettingsCustomisationBackendIndexRoute,
    DashSettingsCustomisationBodyIndexRoute:
      DashSettingsCustomisationBodyIndexRoute,
    DashSettingsCustomisationFooterIndexRoute:
      DashSettingsCustomisationFooterIndexRoute,
    DashSettingsCustomisationGlobalStylesIndexRoute:
      DashSettingsCustomisationGlobalStylesIndexRoute,
    DashSettingsCustomisationHeaderIndexRoute:
      DashSettingsCustomisationHeaderIndexRoute,
    DashSettingsCustomisationPersonalisedVideoIndexRoute:
      DashSettingsCustomisationPersonalisedVideoIndexRoute,
    DashSettingsCustomisationQrCodeIndexRoute:
      DashSettingsCustomisationQrCodeIndexRoute,
  }

const DashSettingsCustomisationRouteRouteWithChildren =
  DashSettingsCustomisationRouteRoute._addFileChildren(
    DashSettingsCustomisationRouteRouteChildren,
  )

interface DashSettingsGeneralRouteRouteChildren {
  DashSettingsGeneralHomePageIndexRoute: typeof DashSettingsGeneralHomePageIndexRoute
  DashSettingsGeneralPrivacyPolicyIndexRoute: typeof DashSettingsGeneralPrivacyPolicyIndexRoute
  DashSettingsGeneralSiteSettingsIndexRoute: typeof DashSettingsGeneralSiteSettingsIndexRoute
  DashSettingsGeneralTagsIndexRoute: typeof DashSettingsGeneralTagsIndexRoute
}

const DashSettingsGeneralRouteRouteChildren: DashSettingsGeneralRouteRouteChildren =
  {
    DashSettingsGeneralHomePageIndexRoute:
      DashSettingsGeneralHomePageIndexRoute,
    DashSettingsGeneralPrivacyPolicyIndexRoute:
      DashSettingsGeneralPrivacyPolicyIndexRoute,
    DashSettingsGeneralSiteSettingsIndexRoute:
      DashSettingsGeneralSiteSettingsIndexRoute,
    DashSettingsGeneralTagsIndexRoute: DashSettingsGeneralTagsIndexRoute,
  }

const DashSettingsGeneralRouteRouteWithChildren =
  DashSettingsGeneralRouteRoute._addFileChildren(
    DashSettingsGeneralRouteRouteChildren,
  )

interface DashSettingsManagementRouteRouteChildren {
  DashSettingsManagementUsersUserRouteRoute: typeof DashSettingsManagementUsersUserRouteRoute
  DashSettingsManagementUsersCreateRoute: typeof DashSettingsManagementUsersCreateRoute
  DashSettingsManagementAnalyticsIndexRoute: typeof DashSettingsManagementAnalyticsIndexRoute
  DashSettingsManagementIntegrationsIndexRoute: typeof DashSettingsManagementIntegrationsIndexRoute
  DashSettingsManagementProfileIndexRoute: typeof DashSettingsManagementProfileIndexRoute
  DashSettingsManagementUsersIndexRoute: typeof DashSettingsManagementUsersIndexRoute
  DashSettingsManagementIntegrationsHubspotIndexRoute: typeof DashSettingsManagementIntegrationsHubspotIndexRoute
}

const DashSettingsManagementRouteRouteChildren: DashSettingsManagementRouteRouteChildren =
  {
    DashSettingsManagementUsersUserRouteRoute:
      DashSettingsManagementUsersUserRouteRoute,
    DashSettingsManagementUsersCreateRoute:
      DashSettingsManagementUsersCreateRoute,
    DashSettingsManagementAnalyticsIndexRoute:
      DashSettingsManagementAnalyticsIndexRoute,
    DashSettingsManagementIntegrationsIndexRoute:
      DashSettingsManagementIntegrationsIndexRoute,
    DashSettingsManagementProfileIndexRoute:
      DashSettingsManagementProfileIndexRoute,
    DashSettingsManagementUsersIndexRoute:
      DashSettingsManagementUsersIndexRoute,
    DashSettingsManagementIntegrationsHubspotIndexRoute:
      DashSettingsManagementIntegrationsHubspotIndexRoute,
  }

const DashSettingsManagementRouteRouteWithChildren =
  DashSettingsManagementRouteRoute._addFileChildren(
    DashSettingsManagementRouteRouteChildren,
  )

interface DashSettingsRouteRouteChildren {
  DashSettingsCustomisationRouteRoute: typeof DashSettingsCustomisationRouteRouteWithChildren
  DashSettingsGeneralRouteRoute: typeof DashSettingsGeneralRouteRouteWithChildren
  DashSettingsManagementRouteRoute: typeof DashSettingsManagementRouteRouteWithChildren
  DashSettingsIndexRoute: typeof DashSettingsIndexRoute
}

const DashSettingsRouteRouteChildren: DashSettingsRouteRouteChildren = {
  DashSettingsCustomisationRouteRoute:
    DashSettingsCustomisationRouteRouteWithChildren,
  DashSettingsGeneralRouteRoute: DashSettingsGeneralRouteRouteWithChildren,
  DashSettingsManagementRouteRoute:
    DashSettingsManagementRouteRouteWithChildren,
  DashSettingsIndexRoute: DashSettingsIndexRoute,
}

const DashSettingsRouteRouteWithChildren =
  DashSettingsRouteRoute._addFileChildren(DashSettingsRouteRouteChildren)

interface DashContentCategoriesRouteRouteChildren {
  DashContentCategoriesIndexRoute: typeof DashContentCategoriesIndexRoute
  DashContentCategoriesIdAddFromCatalogRoute: typeof DashContentCategoriesIdAddFromCatalogRoute
}

const DashContentCategoriesRouteRouteChildren: DashContentCategoriesRouteRouteChildren =
  {
    DashContentCategoriesIndexRoute: DashContentCategoriesIndexRoute,
    DashContentCategoriesIdAddFromCatalogRoute:
      DashContentCategoriesIdAddFromCatalogRoute,
  }

const DashContentCategoriesRouteRouteWithChildren =
  DashContentCategoriesRouteRoute._addFileChildren(
    DashContentCategoriesRouteRouteChildren,
  )

interface DashRouteRouteChildren {
  DashCrmRouteRoute: typeof DashCrmRouteRouteWithChildren
  DashHubsRouteRoute: typeof DashHubsRouteRouteWithChildren
  DashSettingsRouteRoute: typeof DashSettingsRouteRouteWithChildren
  DashContentCategoriesRouteRoute: typeof DashContentCategoriesRouteRouteWithChildren
  DashContentEditIdRoute: typeof DashContentEditIdRoute
  DashContentAddRoute: typeof DashContentAddRoute
  DashZnglistsZnglistEditRoute: typeof DashZnglistsZnglistEditRoute
  DashZnglistsReorderRoute: typeof DashZnglistsReorderRoute
  DashCatalogIndexRoute: typeof DashCatalogIndexRoute
  DashZnglistsIndexRoute: typeof DashZnglistsIndexRoute
  DashAnalyticsIndexLazyRoute: typeof DashAnalyticsIndexLazyRoute
}

const DashRouteRouteChildren: DashRouteRouteChildren = {
  DashCrmRouteRoute: DashCrmRouteRouteWithChildren,
  DashHubsRouteRoute: DashHubsRouteRouteWithChildren,
  DashSettingsRouteRoute: DashSettingsRouteRouteWithChildren,
  DashContentCategoriesRouteRoute: DashContentCategoriesRouteRouteWithChildren,
  DashContentEditIdRoute: DashContentEditIdRoute,
  DashContentAddRoute: DashContentAddRoute,
  DashZnglistsZnglistEditRoute: DashZnglistsZnglistEditRoute,
  DashZnglistsReorderRoute: DashZnglistsReorderRoute,
  DashCatalogIndexRoute: DashCatalogIndexRoute,
  DashZnglistsIndexRoute: DashZnglistsIndexRoute,
  DashAnalyticsIndexLazyRoute: DashAnalyticsIndexLazyRoute,
}

const DashRouteRouteWithChildren = DashRouteRoute._addFileChildren(
  DashRouteRouteChildren,
)

interface IframeApiRouteRouteChildren {
  IframeApiStudioRecordVideoRoute: typeof IframeApiStudioRecordVideoRoute
}

const IframeApiRouteRouteChildren: IframeApiRouteRouteChildren = {
  IframeApiStudioRecordVideoRoute: IframeApiStudioRecordVideoRoute,
}

const IframeApiRouteRouteWithChildren = IframeApiRouteRoute._addFileChildren(
  IframeApiRouteRouteChildren,
)

interface TestRouteRouteChildren {
  TestUiMetaFieldRoute: typeof TestUiMetaFieldRoute
  TestThemeIndexRoute: typeof TestThemeIndexRoute
}

const TestRouteRouteChildren: TestRouteRouteChildren = {
  TestUiMetaFieldRoute: TestUiMetaFieldRoute,
  TestThemeIndexRoute: TestThemeIndexRoute,
}

const TestRouteRouteWithChildren = TestRouteRoute._addFileChildren(
  TestRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dash': typeof DashRouteRouteWithChildren
  '/iframe-api': typeof IframeApiRouteRouteWithChildren
  '/test': typeof TestRouteRouteWithChildren
  '/*': typeof Route
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/view-all': typeof ViewAllRoute
  '/dash/crm': typeof DashCrmRouteRouteWithChildren
  '/dash/hubs': typeof DashHubsRouteRouteWithChildren
  '/dash/settings': typeof DashSettingsRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/oauth-callback': typeof AuthOauthCallbackRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/content/$postId': typeof ContentPostIdRoute
  '/hub/$slug': typeof HubSlugRoute
  '/test/ui-meta-field': typeof TestUiMetaFieldRoute
  '/znglist/$slug': typeof ZnglistSlugRoute
  '/service-desk': typeof ServiceDeskIndexRoute
  '/dash/content/categories': typeof DashContentCategoriesRouteRouteWithChildren
  '/dash/crm/contacts': typeof DashCrmContactsRouteRouteWithChildren
  '/dash/crm/forms': typeof DashCrmFormsRouteRouteWithChildren
  '/dash/settings/customisation': typeof DashSettingsCustomisationRouteRouteWithChildren
  '/dash/settings/general': typeof DashSettingsGeneralRouteRouteWithChildren
  '/dash/settings/management': typeof DashSettingsManagementRouteRouteWithChildren
  '/auth/sso/login': typeof AuthSsoLoginRoute
  '/dash/content/$editId': typeof DashContentEditIdRoute
  '/dash/content/add': typeof DashContentAddRoute
  '/dash/znglists/$znglistEdit': typeof DashZnglistsZnglistEditRoute
  '/dash/znglists/reorder': typeof DashZnglistsReorderRoute
  '/iframe-api/studio/record-video': typeof IframeApiStudioRecordVideoRoute
  '/dash/catalog': typeof DashCatalogIndexRoute
  '/dash/crm/': typeof DashCrmIndexRoute
  '/dash/hubs/': typeof DashHubsIndexRoute
  '/dash/settings/': typeof DashSettingsIndexRoute
  '/dash/znglists': typeof DashZnglistsIndexRoute
  '/test/theme': typeof TestThemeIndexRoute
  '/dash/analytics': typeof DashAnalyticsIndexLazyRoute
  '/dash/crm/contacts/import': typeof DashCrmContactsImportRouteRouteWithChildren
  '/dash/crm/contacts/lists': typeof DashCrmContactsListsRouteRouteWithChildren
  '/dash/crm/forms/$formId': typeof DashCrmFormsFormIdRoute
  '/dash/hubs/hubs/$hubEdit': typeof DashHubsHubsHubEditRoute
  '/dash/hubs/hubs/reorder': typeof DashHubsHubsReorderRoute
  '/dash/hubs/pages/$hubPageEdit': typeof DashHubsPagesHubPageEditRoute
  '/users/$user/znglist/$slug': typeof UsersUserZnglistSlugRoute
  '/dash/content/categories/': typeof DashContentCategoriesIndexRoute
  '/dash/crm/contacts/': typeof DashCrmContactsIndexRoute
  '/dash/crm/forms/': typeof DashCrmFormsIndexRoute
  '/dash/hubs/hubs': typeof DashHubsHubsIndexRoute
  '/dash/hubs/pages': typeof DashHubsPagesIndexRoute
  '/dash/crm/contacts/lists/$listId': typeof DashCrmContactsListsListIdRouteRouteWithChildren
  '/dash/settings/management/users/$user': typeof DashSettingsManagementUsersUserRouteRoute
  '/dash/content/categories/$id/add-from-catalog': typeof DashContentCategoriesIdAddFromCatalogRoute
  '/dash/crm/contacts/contact/$contactId': typeof DashCrmContactsContactContactIdRoute
  '/dash/crm/contacts/contact/new': typeof DashCrmContactsContactNewRoute
  '/dash/crm/contacts/import/step-2': typeof DashCrmContactsImportStep2Route
  '/dash/crm/forms/entries/$entryId': typeof DashCrmFormsEntriesEntryIdRoute
  '/dash/settings/management/users/create': typeof DashSettingsManagementUsersCreateRoute
  '/dash/crm/contacts/import/': typeof DashCrmContactsImportIndexRoute
  '/dash/crm/contacts/lists/': typeof DashCrmContactsListsIndexRoute
  '/dash/crm/forms/entries': typeof DashCrmFormsEntriesIndexRoute
  '/dash/settings/customisation/backend': typeof DashSettingsCustomisationBackendIndexRoute
  '/dash/settings/customisation/body': typeof DashSettingsCustomisationBodyIndexRoute
  '/dash/settings/customisation/footer': typeof DashSettingsCustomisationFooterIndexRoute
  '/dash/settings/customisation/global-styles': typeof DashSettingsCustomisationGlobalStylesIndexRoute
  '/dash/settings/customisation/header': typeof DashSettingsCustomisationHeaderIndexRoute
  '/dash/settings/customisation/personalised-video': typeof DashSettingsCustomisationPersonalisedVideoIndexRoute
  '/dash/settings/customisation/qr-code': typeof DashSettingsCustomisationQrCodeIndexRoute
  '/dash/settings/general/home-page': typeof DashSettingsGeneralHomePageIndexRoute
  '/dash/settings/general/privacy-policy': typeof DashSettingsGeneralPrivacyPolicyIndexRoute
  '/dash/settings/general/site-settings': typeof DashSettingsGeneralSiteSettingsIndexRoute
  '/dash/settings/general/tags': typeof DashSettingsGeneralTagsIndexRoute
  '/dash/settings/management/analytics': typeof DashSettingsManagementAnalyticsIndexRoute
  '/dash/settings/management/integrations': typeof DashSettingsManagementIntegrationsIndexRoute
  '/dash/settings/management/profile': typeof DashSettingsManagementProfileIndexRoute
  '/dash/settings/management/users': typeof DashSettingsManagementUsersIndexRoute
  '/dash/crm/contacts/lists/$listId/filters': typeof DashCrmContactsListsListIdFiltersRoute
  '/dash/crm/contacts/lists/$listId/handpick': typeof DashCrmContactsListsListIdHandpickRoute
  '/dash/crm/contacts/import/file-upload': typeof DashCrmContactsImportFileUploadIndexRoute
  '/dash/crm/contacts/lists/$listId/': typeof DashCrmContactsListsListIdIndexRoute
  '/dash/settings/management/integrations/hubspot': typeof DashSettingsManagementIntegrationsHubspotIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dash': typeof DashRouteRouteWithChildren
  '/iframe-api': typeof IframeApiRouteRouteWithChildren
  '/test': typeof TestRouteRouteWithChildren
  '/*': typeof Route
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/view-all': typeof ViewAllRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/oauth-callback': typeof AuthOauthCallbackRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/content/$postId': typeof ContentPostIdRoute
  '/hub/$slug': typeof HubSlugRoute
  '/test/ui-meta-field': typeof TestUiMetaFieldRoute
  '/znglist/$slug': typeof ZnglistSlugRoute
  '/service-desk': typeof ServiceDeskIndexRoute
  '/dash/settings/customisation': typeof DashSettingsCustomisationRouteRouteWithChildren
  '/dash/settings/general': typeof DashSettingsGeneralRouteRouteWithChildren
  '/dash/settings/management': typeof DashSettingsManagementRouteRouteWithChildren
  '/auth/sso/login': typeof AuthSsoLoginRoute
  '/dash/content/$editId': typeof DashContentEditIdRoute
  '/dash/content/add': typeof DashContentAddRoute
  '/dash/znglists/$znglistEdit': typeof DashZnglistsZnglistEditRoute
  '/dash/znglists/reorder': typeof DashZnglistsReorderRoute
  '/iframe-api/studio/record-video': typeof IframeApiStudioRecordVideoRoute
  '/dash/catalog': typeof DashCatalogIndexRoute
  '/dash/crm': typeof DashCrmIndexRoute
  '/dash/hubs': typeof DashHubsIndexRoute
  '/dash/settings': typeof DashSettingsIndexRoute
  '/dash/znglists': typeof DashZnglistsIndexRoute
  '/test/theme': typeof TestThemeIndexRoute
  '/dash/analytics': typeof DashAnalyticsIndexLazyRoute
  '/dash/crm/forms/$formId': typeof DashCrmFormsFormIdRoute
  '/dash/hubs/hubs/$hubEdit': typeof DashHubsHubsHubEditRoute
  '/dash/hubs/hubs/reorder': typeof DashHubsHubsReorderRoute
  '/dash/hubs/pages/$hubPageEdit': typeof DashHubsPagesHubPageEditRoute
  '/users/$user/znglist/$slug': typeof UsersUserZnglistSlugRoute
  '/dash/content/categories': typeof DashContentCategoriesIndexRoute
  '/dash/crm/contacts': typeof DashCrmContactsIndexRoute
  '/dash/crm/forms': typeof DashCrmFormsIndexRoute
  '/dash/hubs/hubs': typeof DashHubsHubsIndexRoute
  '/dash/hubs/pages': typeof DashHubsPagesIndexRoute
  '/dash/settings/management/users/$user': typeof DashSettingsManagementUsersUserRouteRoute
  '/dash/content/categories/$id/add-from-catalog': typeof DashContentCategoriesIdAddFromCatalogRoute
  '/dash/crm/contacts/contact/$contactId': typeof DashCrmContactsContactContactIdRoute
  '/dash/crm/contacts/contact/new': typeof DashCrmContactsContactNewRoute
  '/dash/crm/contacts/import/step-2': typeof DashCrmContactsImportStep2Route
  '/dash/crm/forms/entries/$entryId': typeof DashCrmFormsEntriesEntryIdRoute
  '/dash/settings/management/users/create': typeof DashSettingsManagementUsersCreateRoute
  '/dash/crm/contacts/import': typeof DashCrmContactsImportIndexRoute
  '/dash/crm/contacts/lists': typeof DashCrmContactsListsIndexRoute
  '/dash/crm/forms/entries': typeof DashCrmFormsEntriesIndexRoute
  '/dash/settings/customisation/backend': typeof DashSettingsCustomisationBackendIndexRoute
  '/dash/settings/customisation/body': typeof DashSettingsCustomisationBodyIndexRoute
  '/dash/settings/customisation/footer': typeof DashSettingsCustomisationFooterIndexRoute
  '/dash/settings/customisation/global-styles': typeof DashSettingsCustomisationGlobalStylesIndexRoute
  '/dash/settings/customisation/header': typeof DashSettingsCustomisationHeaderIndexRoute
  '/dash/settings/customisation/personalised-video': typeof DashSettingsCustomisationPersonalisedVideoIndexRoute
  '/dash/settings/customisation/qr-code': typeof DashSettingsCustomisationQrCodeIndexRoute
  '/dash/settings/general/home-page': typeof DashSettingsGeneralHomePageIndexRoute
  '/dash/settings/general/privacy-policy': typeof DashSettingsGeneralPrivacyPolicyIndexRoute
  '/dash/settings/general/site-settings': typeof DashSettingsGeneralSiteSettingsIndexRoute
  '/dash/settings/general/tags': typeof DashSettingsGeneralTagsIndexRoute
  '/dash/settings/management/analytics': typeof DashSettingsManagementAnalyticsIndexRoute
  '/dash/settings/management/integrations': typeof DashSettingsManagementIntegrationsIndexRoute
  '/dash/settings/management/profile': typeof DashSettingsManagementProfileIndexRoute
  '/dash/settings/management/users': typeof DashSettingsManagementUsersIndexRoute
  '/dash/crm/contacts/lists/$listId/filters': typeof DashCrmContactsListsListIdFiltersRoute
  '/dash/crm/contacts/lists/$listId/handpick': typeof DashCrmContactsListsListIdHandpickRoute
  '/dash/crm/contacts/import/file-upload': typeof DashCrmContactsImportFileUploadIndexRoute
  '/dash/crm/contacts/lists/$listId': typeof DashCrmContactsListsListIdIndexRoute
  '/dash/settings/management/integrations/hubspot': typeof DashSettingsManagementIntegrationsHubspotIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/dash': typeof DashRouteRouteWithChildren
  '/iframe-api': typeof IframeApiRouteRouteWithChildren
  '/test': typeof TestRouteRouteWithChildren
  '/*': typeof Route
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/view-all': typeof ViewAllRoute
  '/dash/crm': typeof DashCrmRouteRouteWithChildren
  '/dash/hubs': typeof DashHubsRouteRouteWithChildren
  '/dash/settings': typeof DashSettingsRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/oauth-callback': typeof AuthOauthCallbackRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/content/$postId': typeof ContentPostIdRoute
  '/hub/$slug': typeof HubSlugRoute
  '/test/ui-meta-field': typeof TestUiMetaFieldRoute
  '/znglist/$slug': typeof ZnglistSlugRoute
  '/service-desk/': typeof ServiceDeskIndexRoute
  '/dash/content/categories': typeof DashContentCategoriesRouteRouteWithChildren
  '/dash/crm/contacts': typeof DashCrmContactsRouteRouteWithChildren
  '/dash/crm/forms': typeof DashCrmFormsRouteRouteWithChildren
  '/dash/settings/customisation': typeof DashSettingsCustomisationRouteRouteWithChildren
  '/dash/settings/general': typeof DashSettingsGeneralRouteRouteWithChildren
  '/dash/settings/management': typeof DashSettingsManagementRouteRouteWithChildren
  '/auth/sso/login': typeof AuthSsoLoginRoute
  '/dash/content/$editId': typeof DashContentEditIdRoute
  '/dash/content/add': typeof DashContentAddRoute
  '/dash/znglists/$znglistEdit': typeof DashZnglistsZnglistEditRoute
  '/dash/znglists/reorder': typeof DashZnglistsReorderRoute
  '/iframe-api/studio/record-video': typeof IframeApiStudioRecordVideoRoute
  '/dash/catalog/': typeof DashCatalogIndexRoute
  '/dash/crm/': typeof DashCrmIndexRoute
  '/dash/hubs/': typeof DashHubsIndexRoute
  '/dash/settings/': typeof DashSettingsIndexRoute
  '/dash/znglists/': typeof DashZnglistsIndexRoute
  '/test/theme/': typeof TestThemeIndexRoute
  '/dash/analytics/': typeof DashAnalyticsIndexLazyRoute
  '/dash/crm/contacts/import': typeof DashCrmContactsImportRouteRouteWithChildren
  '/dash/crm/contacts/lists': typeof DashCrmContactsListsRouteRouteWithChildren
  '/dash/crm/forms/$formId': typeof DashCrmFormsFormIdRoute
  '/dash/hubs/hubs/$hubEdit': typeof DashHubsHubsHubEditRoute
  '/dash/hubs/hubs/reorder': typeof DashHubsHubsReorderRoute
  '/dash/hubs/pages/$hubPageEdit': typeof DashHubsPagesHubPageEditRoute
  '/users/$user/znglist/$slug': typeof UsersUserZnglistSlugRoute
  '/dash/content/categories/': typeof DashContentCategoriesIndexRoute
  '/dash/crm/contacts/': typeof DashCrmContactsIndexRoute
  '/dash/crm/forms/': typeof DashCrmFormsIndexRoute
  '/dash/hubs/hubs/': typeof DashHubsHubsIndexRoute
  '/dash/hubs/pages/': typeof DashHubsPagesIndexRoute
  '/dash/crm/contacts/lists/$listId': typeof DashCrmContactsListsListIdRouteRouteWithChildren
  '/dash/settings/management/users/$user': typeof DashSettingsManagementUsersUserRouteRoute
  '/dash/content/categories/$id/add-from-catalog': typeof DashContentCategoriesIdAddFromCatalogRoute
  '/dash/crm/contacts/contact/$contactId': typeof DashCrmContactsContactContactIdRoute
  '/dash/crm/contacts/contact/new': typeof DashCrmContactsContactNewRoute
  '/dash/crm/contacts/import/step-2': typeof DashCrmContactsImportStep2Route
  '/dash/crm/forms/entries/$entryId': typeof DashCrmFormsEntriesEntryIdRoute
  '/dash/settings/management/users/create': typeof DashSettingsManagementUsersCreateRoute
  '/dash/crm/contacts/import/': typeof DashCrmContactsImportIndexRoute
  '/dash/crm/contacts/lists/': typeof DashCrmContactsListsIndexRoute
  '/dash/crm/forms/entries/': typeof DashCrmFormsEntriesIndexRoute
  '/dash/settings/customisation/backend/': typeof DashSettingsCustomisationBackendIndexRoute
  '/dash/settings/customisation/body/': typeof DashSettingsCustomisationBodyIndexRoute
  '/dash/settings/customisation/footer/': typeof DashSettingsCustomisationFooterIndexRoute
  '/dash/settings/customisation/global-styles/': typeof DashSettingsCustomisationGlobalStylesIndexRoute
  '/dash/settings/customisation/header/': typeof DashSettingsCustomisationHeaderIndexRoute
  '/dash/settings/customisation/personalised-video/': typeof DashSettingsCustomisationPersonalisedVideoIndexRoute
  '/dash/settings/customisation/qr-code/': typeof DashSettingsCustomisationQrCodeIndexRoute
  '/dash/settings/general/home-page/': typeof DashSettingsGeneralHomePageIndexRoute
  '/dash/settings/general/privacy-policy/': typeof DashSettingsGeneralPrivacyPolicyIndexRoute
  '/dash/settings/general/site-settings/': typeof DashSettingsGeneralSiteSettingsIndexRoute
  '/dash/settings/general/tags/': typeof DashSettingsGeneralTagsIndexRoute
  '/dash/settings/management/analytics/': typeof DashSettingsManagementAnalyticsIndexRoute
  '/dash/settings/management/integrations/': typeof DashSettingsManagementIntegrationsIndexRoute
  '/dash/settings/management/profile/': typeof DashSettingsManagementProfileIndexRoute
  '/dash/settings/management/users/': typeof DashSettingsManagementUsersIndexRoute
  '/dash/crm/contacts/lists/$listId/filters': typeof DashCrmContactsListsListIdFiltersRoute
  '/dash/crm/contacts/lists/$listId/handpick': typeof DashCrmContactsListsListIdHandpickRoute
  '/dash/crm/contacts/import/file-upload/': typeof DashCrmContactsImportFileUploadIndexRoute
  '/dash/crm/contacts/lists/$listId/': typeof DashCrmContactsListsListIdIndexRoute
  '/dash/settings/management/integrations/hubspot/': typeof DashSettingsManagementIntegrationsHubspotIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dash'
    | '/iframe-api'
    | '/test'
    | '/*'
    | '/privacy-policy'
    | '/view-all'
    | '/dash/crm'
    | '/dash/hubs'
    | '/dash/settings'
    | '/auth/login'
    | '/auth/oauth-callback'
    | '/auth/password-reset'
    | '/content/$postId'
    | '/hub/$slug'
    | '/test/ui-meta-field'
    | '/znglist/$slug'
    | '/service-desk'
    | '/dash/content/categories'
    | '/dash/crm/contacts'
    | '/dash/crm/forms'
    | '/dash/settings/customisation'
    | '/dash/settings/general'
    | '/dash/settings/management'
    | '/auth/sso/login'
    | '/dash/content/$editId'
    | '/dash/content/add'
    | '/dash/znglists/$znglistEdit'
    | '/dash/znglists/reorder'
    | '/iframe-api/studio/record-video'
    | '/dash/catalog'
    | '/dash/crm/'
    | '/dash/hubs/'
    | '/dash/settings/'
    | '/dash/znglists'
    | '/test/theme'
    | '/dash/analytics'
    | '/dash/crm/contacts/import'
    | '/dash/crm/contacts/lists'
    | '/dash/crm/forms/$formId'
    | '/dash/hubs/hubs/$hubEdit'
    | '/dash/hubs/hubs/reorder'
    | '/dash/hubs/pages/$hubPageEdit'
    | '/users/$user/znglist/$slug'
    | '/dash/content/categories/'
    | '/dash/crm/contacts/'
    | '/dash/crm/forms/'
    | '/dash/hubs/hubs'
    | '/dash/hubs/pages'
    | '/dash/crm/contacts/lists/$listId'
    | '/dash/settings/management/users/$user'
    | '/dash/content/categories/$id/add-from-catalog'
    | '/dash/crm/contacts/contact/$contactId'
    | '/dash/crm/contacts/contact/new'
    | '/dash/crm/contacts/import/step-2'
    | '/dash/crm/forms/entries/$entryId'
    | '/dash/settings/management/users/create'
    | '/dash/crm/contacts/import/'
    | '/dash/crm/contacts/lists/'
    | '/dash/crm/forms/entries'
    | '/dash/settings/customisation/backend'
    | '/dash/settings/customisation/body'
    | '/dash/settings/customisation/footer'
    | '/dash/settings/customisation/global-styles'
    | '/dash/settings/customisation/header'
    | '/dash/settings/customisation/personalised-video'
    | '/dash/settings/customisation/qr-code'
    | '/dash/settings/general/home-page'
    | '/dash/settings/general/privacy-policy'
    | '/dash/settings/general/site-settings'
    | '/dash/settings/general/tags'
    | '/dash/settings/management/analytics'
    | '/dash/settings/management/integrations'
    | '/dash/settings/management/profile'
    | '/dash/settings/management/users'
    | '/dash/crm/contacts/lists/$listId/filters'
    | '/dash/crm/contacts/lists/$listId/handpick'
    | '/dash/crm/contacts/import/file-upload'
    | '/dash/crm/contacts/lists/$listId/'
    | '/dash/settings/management/integrations/hubspot'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dash'
    | '/iframe-api'
    | '/test'
    | '/*'
    | '/privacy-policy'
    | '/view-all'
    | '/auth/login'
    | '/auth/oauth-callback'
    | '/auth/password-reset'
    | '/content/$postId'
    | '/hub/$slug'
    | '/test/ui-meta-field'
    | '/znglist/$slug'
    | '/service-desk'
    | '/dash/settings/customisation'
    | '/dash/settings/general'
    | '/dash/settings/management'
    | '/auth/sso/login'
    | '/dash/content/$editId'
    | '/dash/content/add'
    | '/dash/znglists/$znglistEdit'
    | '/dash/znglists/reorder'
    | '/iframe-api/studio/record-video'
    | '/dash/catalog'
    | '/dash/crm'
    | '/dash/hubs'
    | '/dash/settings'
    | '/dash/znglists'
    | '/test/theme'
    | '/dash/analytics'
    | '/dash/crm/forms/$formId'
    | '/dash/hubs/hubs/$hubEdit'
    | '/dash/hubs/hubs/reorder'
    | '/dash/hubs/pages/$hubPageEdit'
    | '/users/$user/znglist/$slug'
    | '/dash/content/categories'
    | '/dash/crm/contacts'
    | '/dash/crm/forms'
    | '/dash/hubs/hubs'
    | '/dash/hubs/pages'
    | '/dash/settings/management/users/$user'
    | '/dash/content/categories/$id/add-from-catalog'
    | '/dash/crm/contacts/contact/$contactId'
    | '/dash/crm/contacts/contact/new'
    | '/dash/crm/contacts/import/step-2'
    | '/dash/crm/forms/entries/$entryId'
    | '/dash/settings/management/users/create'
    | '/dash/crm/contacts/import'
    | '/dash/crm/contacts/lists'
    | '/dash/crm/forms/entries'
    | '/dash/settings/customisation/backend'
    | '/dash/settings/customisation/body'
    | '/dash/settings/customisation/footer'
    | '/dash/settings/customisation/global-styles'
    | '/dash/settings/customisation/header'
    | '/dash/settings/customisation/personalised-video'
    | '/dash/settings/customisation/qr-code'
    | '/dash/settings/general/home-page'
    | '/dash/settings/general/privacy-policy'
    | '/dash/settings/general/site-settings'
    | '/dash/settings/general/tags'
    | '/dash/settings/management/analytics'
    | '/dash/settings/management/integrations'
    | '/dash/settings/management/profile'
    | '/dash/settings/management/users'
    | '/dash/crm/contacts/lists/$listId/filters'
    | '/dash/crm/contacts/lists/$listId/handpick'
    | '/dash/crm/contacts/import/file-upload'
    | '/dash/crm/contacts/lists/$listId'
    | '/dash/settings/management/integrations/hubspot'
  id:
    | '__root__'
    | '/'
    | '/dash'
    | '/iframe-api'
    | '/test'
    | '/*'
    | '/privacy-policy'
    | '/view-all'
    | '/dash/crm'
    | '/dash/hubs'
    | '/dash/settings'
    | '/auth/login'
    | '/auth/oauth-callback'
    | '/auth/password-reset'
    | '/content/$postId'
    | '/hub/$slug'
    | '/test/ui-meta-field'
    | '/znglist/$slug'
    | '/service-desk/'
    | '/dash/content/categories'
    | '/dash/crm/contacts'
    | '/dash/crm/forms'
    | '/dash/settings/customisation'
    | '/dash/settings/general'
    | '/dash/settings/management'
    | '/auth/sso/login'
    | '/dash/content/$editId'
    | '/dash/content/add'
    | '/dash/znglists/$znglistEdit'
    | '/dash/znglists/reorder'
    | '/iframe-api/studio/record-video'
    | '/dash/catalog/'
    | '/dash/crm/'
    | '/dash/hubs/'
    | '/dash/settings/'
    | '/dash/znglists/'
    | '/test/theme/'
    | '/dash/analytics/'
    | '/dash/crm/contacts/import'
    | '/dash/crm/contacts/lists'
    | '/dash/crm/forms/$formId'
    | '/dash/hubs/hubs/$hubEdit'
    | '/dash/hubs/hubs/reorder'
    | '/dash/hubs/pages/$hubPageEdit'
    | '/users/$user/znglist/$slug'
    | '/dash/content/categories/'
    | '/dash/crm/contacts/'
    | '/dash/crm/forms/'
    | '/dash/hubs/hubs/'
    | '/dash/hubs/pages/'
    | '/dash/crm/contacts/lists/$listId'
    | '/dash/settings/management/users/$user'
    | '/dash/content/categories/$id/add-from-catalog'
    | '/dash/crm/contacts/contact/$contactId'
    | '/dash/crm/contacts/contact/new'
    | '/dash/crm/contacts/import/step-2'
    | '/dash/crm/forms/entries/$entryId'
    | '/dash/settings/management/users/create'
    | '/dash/crm/contacts/import/'
    | '/dash/crm/contacts/lists/'
    | '/dash/crm/forms/entries/'
    | '/dash/settings/customisation/backend/'
    | '/dash/settings/customisation/body/'
    | '/dash/settings/customisation/footer/'
    | '/dash/settings/customisation/global-styles/'
    | '/dash/settings/customisation/header/'
    | '/dash/settings/customisation/personalised-video/'
    | '/dash/settings/customisation/qr-code/'
    | '/dash/settings/general/home-page/'
    | '/dash/settings/general/privacy-policy/'
    | '/dash/settings/general/site-settings/'
    | '/dash/settings/general/tags/'
    | '/dash/settings/management/analytics/'
    | '/dash/settings/management/integrations/'
    | '/dash/settings/management/profile/'
    | '/dash/settings/management/users/'
    | '/dash/crm/contacts/lists/$listId/filters'
    | '/dash/crm/contacts/lists/$listId/handpick'
    | '/dash/crm/contacts/import/file-upload/'
    | '/dash/crm/contacts/lists/$listId/'
    | '/dash/settings/management/integrations/hubspot/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashRouteRoute: typeof DashRouteRouteWithChildren
  IframeApiRouteRoute: typeof IframeApiRouteRouteWithChildren
  TestRouteRoute: typeof TestRouteRouteWithChildren
  Route: typeof Route
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ViewAllRoute: typeof ViewAllRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthOauthCallbackRoute: typeof AuthOauthCallbackRoute
  AuthPasswordResetRoute: typeof AuthPasswordResetRoute
  ContentPostIdRoute: typeof ContentPostIdRoute
  HubSlugRoute: typeof HubSlugRoute
  ZnglistSlugRoute: typeof ZnglistSlugRoute
  ServiceDeskIndexRoute: typeof ServiceDeskIndexRoute
  AuthSsoLoginRoute: typeof AuthSsoLoginRoute
  UsersUserZnglistSlugRoute: typeof UsersUserZnglistSlugRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashRouteRoute: DashRouteRouteWithChildren,
  IframeApiRouteRoute: IframeApiRouteRouteWithChildren,
  TestRouteRoute: TestRouteRouteWithChildren,
  Route: Route,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ViewAllRoute: ViewAllRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthOauthCallbackRoute: AuthOauthCallbackRoute,
  AuthPasswordResetRoute: AuthPasswordResetRoute,
  ContentPostIdRoute: ContentPostIdRoute,
  HubSlugRoute: HubSlugRoute,
  ZnglistSlugRoute: ZnglistSlugRoute,
  ServiceDeskIndexRoute: ServiceDeskIndexRoute,
  AuthSsoLoginRoute: AuthSsoLoginRoute,
  UsersUserZnglistSlugRoute: UsersUserZnglistSlugRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/dash",
        "/iframe-api",
        "/test",
        "/*",
        "/privacy-policy",
        "/view-all",
        "/auth/login",
        "/auth/oauth-callback",
        "/auth/password-reset",
        "/content/$postId",
        "/hub/$slug",
        "/znglist/$slug",
        "/service-desk/",
        "/auth/sso/login",
        "/users/$user/znglist/$slug"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/dash": {
      "filePath": "dash/route.tsx",
      "children": [
        "/dash/crm",
        "/dash/hubs",
        "/dash/settings",
        "/dash/content/categories",
        "/dash/content/$editId",
        "/dash/content/add",
        "/dash/znglists/$znglistEdit",
        "/dash/znglists/reorder",
        "/dash/catalog/",
        "/dash/znglists/",
        "/dash/analytics/"
      ]
    },
    "/iframe-api": {
      "filePath": "iframe-api/route.tsx",
      "children": [
        "/iframe-api/studio/record-video"
      ]
    },
    "/test": {
      "filePath": "test/route.tsx",
      "children": [
        "/test/ui-meta-field",
        "/test/theme/"
      ]
    },
    "/*": {
      "filePath": "*.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.tsx"
    },
    "/view-all": {
      "filePath": "view-all.tsx"
    },
    "/dash/crm": {
      "filePath": "dash/crm/route.tsx",
      "parent": "/dash",
      "children": [
        "/dash/crm/contacts",
        "/dash/crm/forms",
        "/dash/crm/"
      ]
    },
    "/dash/hubs": {
      "filePath": "dash/hubs/route.tsx",
      "parent": "/dash",
      "children": [
        "/dash/hubs/",
        "/dash/hubs/hubs/$hubEdit",
        "/dash/hubs/hubs/reorder",
        "/dash/hubs/pages/$hubPageEdit",
        "/dash/hubs/hubs/",
        "/dash/hubs/pages/"
      ]
    },
    "/dash/settings": {
      "filePath": "dash/settings/route.tsx",
      "parent": "/dash",
      "children": [
        "/dash/settings/customisation",
        "/dash/settings/general",
        "/dash/settings/management",
        "/dash/settings/"
      ]
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/auth/oauth-callback": {
      "filePath": "auth/oauth-callback.tsx"
    },
    "/auth/password-reset": {
      "filePath": "auth/password-reset.tsx"
    },
    "/content/$postId": {
      "filePath": "content.$postId.tsx"
    },
    "/hub/$slug": {
      "filePath": "hub.$slug.tsx"
    },
    "/test/ui-meta-field": {
      "filePath": "test/ui-meta-field.tsx",
      "parent": "/test"
    },
    "/znglist/$slug": {
      "filePath": "znglist.$slug.tsx"
    },
    "/service-desk/": {
      "filePath": "service-desk/index.tsx"
    },
    "/dash/content/categories": {
      "filePath": "dash/content/categories/route.tsx",
      "parent": "/dash",
      "children": [
        "/dash/content/categories/",
        "/dash/content/categories/$id/add-from-catalog"
      ]
    },
    "/dash/crm/contacts": {
      "filePath": "dash/crm/contacts/route.tsx",
      "parent": "/dash/crm",
      "children": [
        "/dash/crm/contacts/import",
        "/dash/crm/contacts/lists",
        "/dash/crm/contacts/",
        "/dash/crm/contacts/contact/$contactId",
        "/dash/crm/contacts/contact/new"
      ]
    },
    "/dash/crm/forms": {
      "filePath": "dash/crm/forms/route.tsx",
      "parent": "/dash/crm",
      "children": [
        "/dash/crm/forms/$formId",
        "/dash/crm/forms/",
        "/dash/crm/forms/entries/$entryId",
        "/dash/crm/forms/entries/"
      ]
    },
    "/dash/settings/customisation": {
      "filePath": "dash/settings/customisation/route.tsx",
      "parent": "/dash/settings",
      "children": [
        "/dash/settings/customisation/backend/",
        "/dash/settings/customisation/body/",
        "/dash/settings/customisation/footer/",
        "/dash/settings/customisation/global-styles/",
        "/dash/settings/customisation/header/",
        "/dash/settings/customisation/personalised-video/",
        "/dash/settings/customisation/qr-code/"
      ]
    },
    "/dash/settings/general": {
      "filePath": "dash/settings/general/route.tsx",
      "parent": "/dash/settings",
      "children": [
        "/dash/settings/general/home-page/",
        "/dash/settings/general/privacy-policy/",
        "/dash/settings/general/site-settings/",
        "/dash/settings/general/tags/"
      ]
    },
    "/dash/settings/management": {
      "filePath": "dash/settings/management/route.tsx",
      "parent": "/dash/settings",
      "children": [
        "/dash/settings/management/users/$user",
        "/dash/settings/management/users/create",
        "/dash/settings/management/analytics/",
        "/dash/settings/management/integrations/",
        "/dash/settings/management/profile/",
        "/dash/settings/management/users/",
        "/dash/settings/management/integrations/hubspot/"
      ]
    },
    "/auth/sso/login": {
      "filePath": "auth/sso/login.tsx"
    },
    "/dash/content/$editId": {
      "filePath": "dash/content/$editId.tsx",
      "parent": "/dash"
    },
    "/dash/content/add": {
      "filePath": "dash/content/add.tsx",
      "parent": "/dash"
    },
    "/dash/znglists/$znglistEdit": {
      "filePath": "dash/znglists/$znglistEdit.tsx",
      "parent": "/dash"
    },
    "/dash/znglists/reorder": {
      "filePath": "dash/znglists/reorder.tsx",
      "parent": "/dash"
    },
    "/iframe-api/studio/record-video": {
      "filePath": "iframe-api/studio/record-video.tsx",
      "parent": "/iframe-api"
    },
    "/dash/catalog/": {
      "filePath": "dash/catalog/index.tsx",
      "parent": "/dash"
    },
    "/dash/crm/": {
      "filePath": "dash/crm/index.tsx",
      "parent": "/dash/crm"
    },
    "/dash/hubs/": {
      "filePath": "dash/hubs/index.tsx",
      "parent": "/dash/hubs"
    },
    "/dash/settings/": {
      "filePath": "dash/settings/index.tsx",
      "parent": "/dash/settings"
    },
    "/dash/znglists/": {
      "filePath": "dash/znglists/index.tsx",
      "parent": "/dash"
    },
    "/test/theme/": {
      "filePath": "test/theme/index.tsx",
      "parent": "/test"
    },
    "/dash/analytics/": {
      "filePath": "dash/analytics/index.lazy.tsx",
      "parent": "/dash"
    },
    "/dash/crm/contacts/import": {
      "filePath": "dash/crm/contacts/import/route.tsx",
      "parent": "/dash/crm/contacts",
      "children": [
        "/dash/crm/contacts/import/step-2",
        "/dash/crm/contacts/import/",
        "/dash/crm/contacts/import/file-upload/"
      ]
    },
    "/dash/crm/contacts/lists": {
      "filePath": "dash/crm/contacts/lists/route.tsx",
      "parent": "/dash/crm/contacts",
      "children": [
        "/dash/crm/contacts/lists/$listId",
        "/dash/crm/contacts/lists/"
      ]
    },
    "/dash/crm/forms/$formId": {
      "filePath": "dash/crm/forms/$formId.tsx",
      "parent": "/dash/crm/forms"
    },
    "/dash/hubs/hubs/$hubEdit": {
      "filePath": "dash/hubs/hubs/$hubEdit.tsx",
      "parent": "/dash/hubs"
    },
    "/dash/hubs/hubs/reorder": {
      "filePath": "dash/hubs/hubs/reorder.tsx",
      "parent": "/dash/hubs"
    },
    "/dash/hubs/pages/$hubPageEdit": {
      "filePath": "dash/hubs/pages/$hubPageEdit.tsx",
      "parent": "/dash/hubs"
    },
    "/users/$user/znglist/$slug": {
      "filePath": "users.$user.znglist.$slug.tsx"
    },
    "/dash/content/categories/": {
      "filePath": "dash/content/categories/index.tsx",
      "parent": "/dash/content/categories"
    },
    "/dash/crm/contacts/": {
      "filePath": "dash/crm/contacts/index.tsx",
      "parent": "/dash/crm/contacts"
    },
    "/dash/crm/forms/": {
      "filePath": "dash/crm/forms/index.tsx",
      "parent": "/dash/crm/forms"
    },
    "/dash/hubs/hubs/": {
      "filePath": "dash/hubs/hubs/index.tsx",
      "parent": "/dash/hubs"
    },
    "/dash/hubs/pages/": {
      "filePath": "dash/hubs/pages/index.tsx",
      "parent": "/dash/hubs"
    },
    "/dash/crm/contacts/lists/$listId": {
      "filePath": "dash/crm/contacts/lists/$listId/route.tsx",
      "parent": "/dash/crm/contacts/lists",
      "children": [
        "/dash/crm/contacts/lists/$listId/filters",
        "/dash/crm/contacts/lists/$listId/handpick",
        "/dash/crm/contacts/lists/$listId/"
      ]
    },
    "/dash/settings/management/users/$user": {
      "filePath": "dash/settings/management/users/$user/route.tsx",
      "parent": "/dash/settings/management"
    },
    "/dash/content/categories/$id/add-from-catalog": {
      "filePath": "dash/content/categories/$id.add-from-catalog.tsx",
      "parent": "/dash/content/categories"
    },
    "/dash/crm/contacts/contact/$contactId": {
      "filePath": "dash/crm/contacts/contact/$contactId.tsx",
      "parent": "/dash/crm/contacts"
    },
    "/dash/crm/contacts/contact/new": {
      "filePath": "dash/crm/contacts/contact/new.tsx",
      "parent": "/dash/crm/contacts"
    },
    "/dash/crm/contacts/import/step-2": {
      "filePath": "dash/crm/contacts/import/step-2.tsx",
      "parent": "/dash/crm/contacts/import"
    },
    "/dash/crm/forms/entries/$entryId": {
      "filePath": "dash/crm/forms/entries/$entryId.tsx",
      "parent": "/dash/crm/forms"
    },
    "/dash/settings/management/users/create": {
      "filePath": "dash/settings/management/users/create.tsx",
      "parent": "/dash/settings/management"
    },
    "/dash/crm/contacts/import/": {
      "filePath": "dash/crm/contacts/import/index.tsx",
      "parent": "/dash/crm/contacts/import"
    },
    "/dash/crm/contacts/lists/": {
      "filePath": "dash/crm/contacts/lists/index.tsx",
      "parent": "/dash/crm/contacts/lists"
    },
    "/dash/crm/forms/entries/": {
      "filePath": "dash/crm/forms/entries/index.tsx",
      "parent": "/dash/crm/forms"
    },
    "/dash/settings/customisation/backend/": {
      "filePath": "dash/settings/customisation/backend/index.tsx",
      "parent": "/dash/settings/customisation"
    },
    "/dash/settings/customisation/body/": {
      "filePath": "dash/settings/customisation/body/index.tsx",
      "parent": "/dash/settings/customisation"
    },
    "/dash/settings/customisation/footer/": {
      "filePath": "dash/settings/customisation/footer/index.tsx",
      "parent": "/dash/settings/customisation"
    },
    "/dash/settings/customisation/global-styles/": {
      "filePath": "dash/settings/customisation/global-styles/index.tsx",
      "parent": "/dash/settings/customisation"
    },
    "/dash/settings/customisation/header/": {
      "filePath": "dash/settings/customisation/header/index.tsx",
      "parent": "/dash/settings/customisation"
    },
    "/dash/settings/customisation/personalised-video/": {
      "filePath": "dash/settings/customisation/personalised-video/index.tsx",
      "parent": "/dash/settings/customisation"
    },
    "/dash/settings/customisation/qr-code/": {
      "filePath": "dash/settings/customisation/qr-code/index.tsx",
      "parent": "/dash/settings/customisation"
    },
    "/dash/settings/general/home-page/": {
      "filePath": "dash/settings/general/home-page/index.tsx",
      "parent": "/dash/settings/general"
    },
    "/dash/settings/general/privacy-policy/": {
      "filePath": "dash/settings/general/privacy-policy/index.tsx",
      "parent": "/dash/settings/general"
    },
    "/dash/settings/general/site-settings/": {
      "filePath": "dash/settings/general/site-settings/index.tsx",
      "parent": "/dash/settings/general"
    },
    "/dash/settings/general/tags/": {
      "filePath": "dash/settings/general/tags/index.tsx",
      "parent": "/dash/settings/general"
    },
    "/dash/settings/management/analytics/": {
      "filePath": "dash/settings/management/analytics/index.tsx",
      "parent": "/dash/settings/management"
    },
    "/dash/settings/management/integrations/": {
      "filePath": "dash/settings/management/integrations/index.tsx",
      "parent": "/dash/settings/management"
    },
    "/dash/settings/management/profile/": {
      "filePath": "dash/settings/management/profile/index.tsx",
      "parent": "/dash/settings/management"
    },
    "/dash/settings/management/users/": {
      "filePath": "dash/settings/management/users/index.tsx",
      "parent": "/dash/settings/management"
    },
    "/dash/crm/contacts/lists/$listId/filters": {
      "filePath": "dash/crm/contacts/lists/$listId/filters.tsx",
      "parent": "/dash/crm/contacts/lists/$listId"
    },
    "/dash/crm/contacts/lists/$listId/handpick": {
      "filePath": "dash/crm/contacts/lists/$listId/handpick.tsx",
      "parent": "/dash/crm/contacts/lists/$listId"
    },
    "/dash/crm/contacts/import/file-upload/": {
      "filePath": "dash/crm/contacts/import/file-upload/index.tsx",
      "parent": "/dash/crm/contacts/import"
    },
    "/dash/crm/contacts/lists/$listId/": {
      "filePath": "dash/crm/contacts/lists/$listId/index.tsx",
      "parent": "/dash/crm/contacts/lists/$listId"
    },
    "/dash/settings/management/integrations/hubspot/": {
      "filePath": "dash/settings/management/integrations/hubspot/index.tsx",
      "parent": "/dash/settings/management"
    }
  }
}
ROUTE_MANIFEST_END */
